// 德语 German
import deLocale from "element-ui/lib/locale/lang/de";
const de = {
  login: {
    buttoo: {
      add: "add",
    },
  },
  dialog: {
    buttton: {
      close: "Schließen",
    },
    ReportError: {
      next: "als nächstes",
      h1: "Report Errors ermöglicht es Benutzern, mit uns zu kommunizieren, um etwaige Datenprobleme zu lösen und die Datenqualität zu verbessern.",
      li1: "Wenn Sie Datenprobleme feststellen oder eine Frage zu diesen Daten haben",
      li2: "Wenn Sie Unternehmensinformationen beitragen möchten, um diese Daten zu verbessern",
      li3: "Wenn Sie sich dafür entscheiden, Ihre eigenen Unternehmensinformationen nicht offenzulegen, könnten Sie diese als privat betrachten",
      li4: "Wenn Sie konstruktive Vorschläge zur Verbesserung unserer Dienstleistungen haben",
      h2: "Alle eingereichten Kommentare unterliegen einer Datenüberprüfung. Benutzer müssen Ihr eigenes Benutzerprofil ausfüllen, da unser Vertreter Sie möglicherweise zur Authentifizierung und Überprüfung Ihrer Rechte zur Vertretung Ihres Unternehmens kontaktieren wird.",
      Iamanemployeeofthissubjectcompany:
        "Ich bin ein Mitarbeiter des betreffenden Unternehmens.",
      Reportmycompany: "Melden Sie mein Unternehmen",
      Updatedata: "Daten aktualisieren",
      Reportinformationerrors: "Fehler in den Meldeinformationen",
      Reportotherscompany: "Melden Sie andere Unternehmen",
      Financial: "Finanzielle",
      Pleaseprovidemoreinfo: "Bitte geben Sie weitere Informationen an",
      Year: "Jahr",
      Business: "Geschäft",
      Noofemployees: "Anzahl der Mitarbeiter",
      Coremanagement: "Kernmanagement",
      Corebusinessactivites: "Kerngeschäftsaktivitäten",
      IntBusiness: "Internationales Geschäft",
      Pleasedescribeyouractivites: "Bitte beschreiben Sie Ihre Aktivitäten",
      Pleaselistcountriesyoudobusine:
        "Bitte listen Sie die Länder auf, in denen Sie geschäftlich tätig sind",
      Corecompetency: "Kernkompetenz",
      Businessoutlook: "Geschäftsausblick",
      Uploadfiles: "Dateien hochladen",
      Upload: "Hochladen",
      Cancel: "Abbrechen",
      Submit: "Einreichen",
      Select: "Auswählen",
      Selectthedatacategoryyoureport:
        "Wählen Sie die Datenkategorie aus, über die Sie berichten",
      TotalCurrentAssets: "Umlaufvermögen insgesamt",
      CashBank: "Kasse und Bank",
      Accountreceivable: "Forderungen",
      AdvancestoSuppliers: "Vorschüsse an Lieferanten",
      Inventory: "Inventar",
      Tobeappointedexpense: "Abzugrenzende Aufwendungen",
      Totalnoncurrentassets: "Gesamtvermögen",
      Longterminvestment: "Langfristige Investition",
      Fixedassetsnetvalue: "Nettowert der Sachanlagen",
      Projectsunderconstruction: "Projekte im Bau",
      Longtermtobeappointedexpenise: "Langfristig zu besetzende Ausgaben",
      Deferredtaxdebit: "Latente Steuerbelastung",
      Totalcurrentliabilities: "Gesamtverbindlichkeiten",
      Accountpayable: "Abbrechnungsverbindlichkeiten",
      Advancesfromclients: "Anzahlungen von Kunden",
      Salariespayable: "auszuzahlende Gehälter",
      Taxespayable: "Zu zahlende Steuern",
      Otheraccountspayable: "Sonstige Verbindlichkeiten",
      Totalequity: "Gesamtes Eigenkapital",
      Paidupcapital: "Gezeichnetes Kapital",
      Capitalreserves: "Kapitalrücklagen",
      Surplusreserves: "Gewinnrücklagen",
      Undistrbutedporfit: "Nicht ausgeschütteter Gewinn",
      Totalassets: "Bilanzsumme",
      Turnover: "Umsatz",
      Costofgoodssold: "Kosten der verkauften Waren",
      Salestax: "Umsatzsteuer",
      Grossprofit: "Bruttogewinn",
      Otheroperatingprofils: "Andere Betriebsprofile",
      Salesexpense: "Vertriebsaufwand",
      Managementexpense: "Verwaltungskosten",
      Financeexpense: "Finanzaufwand",
      Operatingprofit: "Betriebsergebnis",
      Nonoperatingincome: "Nicht-operative Erträge",
      Profitbeforetax: "Gewinn vor Steuern",
      Incometax: "Einkommensteuer",
      Netincome: "Nettoeinkommen",
      DataProblems: "Datenprobleme",
      CorrectInformation: "Korrekte Informationen",
    },
  },

  Home: {
    Applications: "Anwendungen",
    SearchCompanies: "Suchen Sie nach Unternehmen",
    SearchLeads: "Suche nach Leads",
    SearchTrade: "Suche Handel",
    SearchSanctions: "Suchsanktionen",
    SearchNews: "Suchen Sie nach Nachrichten",
    RiskScan: "Risikoscan",
    SearchRelationship: "Suchbeziehung",
    DataServices: "Datendienste",
    SearchCountries: "Länder suchen",
    selectCountry: "Land auswählen",
    Entercompanyname: "Firmennamen eingeben",
    keWord: "Stichwort",
    firstWord: "Genau links",
    search: "Suchen",
    homeSeachTitle: "Globales Geschäft im Fokus",
    homeTitleDetail:
      "CSI, ein datenbasiertes Research- und IT-Unternehmen, ist auf Kredite, Risiken und Big Data spezialisiert. Es bietet globalen Investoren und Geschäftsleuten digitale Tools und nutzt fortschrittliche Analysen und Algorithmen, um schnelle, visuelle Einblicke zu liefern und so fundiertere Entscheidungen zu ermöglichen.",
    phoneTitleDetail:
      "Um schnell Unternehmensinformationen zu suchen, anzuzeigen und abzurufen, können Sie auch die CSI-App auf Ihrem Smartphone nutzen.",
    searchCompanyNum:
      "Durchsuchen Sie über 500 Millionen Unternehmen in über 200 Ländern und Territorien",
    newsHeadTitle:
      "Entdecken Sie die strategischen Erkenntnisse hinter jeder Unternehmensschlagzeile",
    sanctionHeadTitle:
      "Navigieren Sie souverän durch den internationalen Handel, indem Sie Unternehmen und Produkte auf globale Sanktionen überprüfen",
    tradeHeadTitle:
      "Globale Handelsdaten in strategische Markteinblicke umwandeln",
    relationshipTitle:
      "Ultimative Eigentums- und Kontrollbefugnisse / Investitionsvolumen / Lieferkettennetzwerk / Optimierung der Compliance / Risikominderung / Globale Abdeckung",
    IndustryAnalysis: "Branchenanalyse",
    BusinessAnalytics: "Geschäftsanalysen",
    ImportExportData: "Import-Export-Daten",
    CompanyNews: "Unternehmensnachrichten",
    Sanctions: "Sanktionen",
    BusinessIntelligence: "Business Intelligence",
    CompanyIdentityVerification: "Überprüfung der Unternehmensidentität",
    KYCSolutions: "KYC-Lösungen",
    OwnershipPenetration: "Eigentumsdurchdringung",
    CompanyFinancialAnalysis: "Finanzanalyse des Unternehmens",
    CreditRatings: "Bonitätsbewertungen",
    CreditReports: "Kreditauskünfte",
    ESGRatings: "ESG-Ratings",
    VendorScreening: "Lieferantenüberprüfung",
    MarketResearch: "Marktforschung",
    EnterKeyword: "Stichwort eingeben",
    Country: "Land",
    Company: "Unternehmen",
    Person: "Person",
    Product: "Produkt",
    EnterPersonName: "Geben Sie den Namen der Person ein",
    EnterCountryName: "Ländernamen eingeben",
    EnterproductName: "Produkt-Keywords eingeben",
    EnterproductNamekeywordsorHSCode:
      "Geben Sie Produktschlüsselwörter oder HS-Code ein",
    Searchby: "Suche nach",
    SICStandardIndustryCode: "SIC - Industriestandard",
    HSCodeHarmonizedSystemCode: "HS-Code - Harmonisiertes System",
    AIAssistance: "KI-Unterstützung",
    EnterISICNACENAICSCSICAAAICGICS:
      "Geben Sie ISIC / NACE / NAICS / CSIC / AAAIC / GICS ein",
    EnterHarmonizedSystemCode:
      "Geben Sie den Code des Harmonisierten Systems ein.",
    SIC: "SIC",
    HSCode: "HSCode",
    Tips:"Tipps",
    detailconttext:
      "Die Funktion, auf die Sie zugreifen möchten, ist Teil unserer Premium-Mitgliedschaft. Um diese Funktion und alle Premium-Funktionen nutzen zu können, abonnieren Sie bitte unsere Mitgliedschaft.",
    Subscribe: "Abonnieren",
  },
  Toolbar: {
    Filter: "Filtern",
    Select: "Auswählen",
    Edit: "Bearbeiten",
    Sortby: "Sortieren nach",
    Collect: "Sammeln",
    Saved: "Gespeichert",
    Compare: "Vergleichen",
    Export: "Exportieren",
    Download: "Herunterladen",
    Update: "Aktualisieren",
    Reporterror: "Fehler melden",
    Share: "Teilen",
    ascending: "aufsteigend",
    descending: "absteigend",
    Yourfolder: "Ihr Ordner",
    RiskScanning: "Optimieren",
    CreditAssessment: "Optimieren",
    DataAnalysis: "Datenanalyse",
    NewPortfolio: "Neues Portfolio",
    Print: "Drucken",
    Optimize: "Optimieren",
    ALL: "Alle",
    Confirm: "Bestätigen",
  },
  Export: {
    Choosethedatafields:
      "Wählen Sie die Datenfelder aus, die Sie exportieren möchten.",
    Enterkeywords: "Schlüsselwörter eingeben",
    Financialdata: "Finanzdaten",
    Reset: "Zurücksetzen",
    Back: "Zurück",
    Howmanyresults:
      "Wie viele Ergebnisse möchten Sie aus dieser Suche exportieren? Sie können Ihre Suche auch durch zusätzliche Filter präzisieren",
    FileName: "Dateiname",
    Pleaseenterafilename: "Bitte geben Sie einen Dateinamen ein",
    SelectedList: "Ausgewählte Liste",
  },
  AiZaba: {
    whatareyousearchingfor: "Was suchst du?",
    CreditAnalyst: "Kreditanalyst",
    Assesses:
      "Beurteilt die Kreditwürdigkeit eines Unternehmens, identifiziert finanzielle Risiken und sorgt durch Datenanalyse und Bonitätsbewertung für sichere Transaktionen.",
    LegalAdvisor: "Rechtsberater",
    Provides:
      "Bietet Compliance-Anleitungen, überprüft Verträge und bewertet rechtliche Risiken, um sicherzustellen, dass der Geschäftsbetrieb den Gesetzen entspricht und Streitigkeiten vermieden werden.",
    BizConsultant: "Geschäftsberater",
    Optimizes:
      "Optimiert Lieferketten, identifiziert Käufer und steigert den Umsatz durch die Analyse von Markttrends und das Angebot maßgeschneiderter Strategien zur Effizienzsteigerung.",
    EconomicAnalyst: "Wirtschaftsanalyst",
    Analyzes:
      "Analysiert Branchen- und regionale Wirtschaftstrends und hilft Unternehmen treffen fundierte Entscheidungen und bleiben wettbewerbsfähig.",
    HiImZabaYourresearchassistant:
      "Hallo, ich bin Zaba – Ihre Forschungsassistentin",
  },
  navigationBar: {
    Notifications: "Benachrichtigungen", //通知
    MarkasRead: "Als gelesen markieren", //标记已读
    Viewall: "Alle anzeigen", //查看全部
    SilverSubscriber: "Silber-Abonnent", //银级用户
    GoldSubscriber: "Gold-Abonnent", //金级用户
    SubscriptionExpires: "Abonnement läuft ab",
    AvailableCredits: "Verfügbare Credits", //可用积分
    AddCredits: "Credits hinzufügen", //购买积分
    IndivdualAccount: "Einzelkonto", //个人账号
    GroupAccount: "Gruppenkonto", //集团账号
    UserAccount: "Benutzerkonto",
    Roles: "Rollen", //角色
    Thereiscurrentlynonewnews: "Es gibt derzeit keine neuen Nachrichten",
    EnterTitleContent:"Titelinhalt eingeben",
  },
  ListofResults: {
    Country: "Land",
    Industry: "Branche",
    CompanyType: "Unternehmensart",
    CompanySize: "Unternehmensgröße",
    CompanyStatus: "Unternehmensstatus",
    CompanyName: "Firmenname",
    RegStatus: "Registrierungsstatus",
    StateProvince: "Bundesland/Provinz",
    CityCounty: "Stadt/Landkreis",
    DistrictCity: "Bezirk/Stadt",
    IncDate: "Gründungsdatum",
    LegalForm: "Rechtsform",
    CoID: "Firmen-ID",
    TaxNo: "Steuernummer",
    ListingInfo: "Eintragsdaten",
    Phone: "Telefon",
    Website: "Website",
    Email: "E-Mail",
    LegalPerson: "Juristische Person",
    PostCode: "Postleitzahl",
    ISIC: "ISIC",
    IndustryDescription: "Branchenbeschreibung",
    NACE: "NACE",
    NAICS: "NAICS",
    CreditRating: "Bonität",
    SolvencyIndex: "Solvenzindex",
    ProbabilityofDefault: "Ausfallwahrscheinlichkeit",
    NoofEmployees: "Anzahl der Mitarbeiter",
    Revenue: "Umsatz",
    TotalAsset: "Gesamtvermögen",
    NetProfit: "Nettogewinn",
    ROA: "ROA",
    ROE: "ROE",
    ShowMore: "Mehr anzeigen",
    SelectCountry: "Wählen Sie Land aus",
    ClearAll: "Alles löschen",
    SelectIndustry: "Wählen Sie Branche aus",
    ListedCompany: "Börsennotiertes Unternehmen",
    YearsinBusiness: "Jahre im Geschäft",
    Sharethisinformation: "Teilen Sie diese Informationen",
    Pleaseaddress: "Bitte geben Sie eine oder mehrere E-Mail-Adressen ein",
    Example: "Beispiel",
    message: "Nachricht",
    pleaseleaveamessage: "Bitte hinterlassen Sie eine Nachricht",
    Include: "Einbeziehen",
    thisaddress: "dieser Firmenname, ID, Adresse",
    CSIwebsite: "CSI-Website",
    Update: "Aktualisieren",
    Iftheavailable:
      "Wenn die verfügbaren Online-Daten nicht ausreichen oder veraltet sind, können Sie auf die Schaltfläche „Aktualisieren“ klicken, um von unseren lokalen Netzwerkermittlern oder Kreditauskunfteien eine sofortige Aktualisierung einer neu untersuchten Unternehmenskreditauskunft anzufordern. Die Kosten für dieses Update betragen 1 Credit pro Unternehmen. Die Zustellung des Aktualisierungsberichts dauert in der Regel zwischen 24 und 72 Stunden.",
    Abusinesscredit:
      "Eine Geschäftskreditauskunft bietet detaillierte Informationen über die Identifikationsdaten des betreffenden Unternehmens, Registereinträge, Beteiligungsstruktur, Unternehmensgeschichte, Managementbeschreibung, verbundene Unternehmen, tatsächliche Geschäftstätigkeiten, Handelsreferenzen, Finanzdaten und -analysen, offizielle öffentliche Informationen wie Prozessaufzeichnungen und Sanktionen sowie Kreditanalyse und -bewertung.",
    Searchcompanies: "Durchsuchen Sie weitere E-Mails anderer Unternehmen",
    Rowsperpage: "Zeilen pro Seite",
    Remove: "Entfernen",
    Confirm: "Bestätigen",
  },
  ContentTabs: {
    Background: "Hintergrund",
    BusinessActivities: "Geschäftstätigkeit",
    Performance: "Performance",
    Publications: "Publikationen",
    CreditOpinion: "Kreditgutachten",
    MarketAnalysis: "Marktanalyse",
    Snapshot: "Kurzfassung",
    Profile: "Profil",
    Ownership: "Eigentümerschaft",
    RelatedCompanies: "Verbundene Unternehmen",
    Management: "Management",
    Operations: "Geschäftstätigkeit",
    Locations: "Standorte",
    Industry: "Branche",
    ImportExport: "Import & Export",
    SupplyChain: "Lieferkette",
    FinancialHighlights: "Finanzielle Highlights",
    RatioAnalysis: "Kennzahlenanalyse",
    IndustryNorm: "Branchennorm",
    News: "News",
    Sanctions: "Sanktionen",
    IndustryStatistics: "Branchenstatistik",
    RatingAnalysis: "Ratinganalyse",
    CompetitiveAnalysis: "Wettbewerbsanalyse",
  },
  Snapshot: {
    CompanyDQIdesc1:
      "Der Data Quality Index (DQI) nutzt Algorithmen, um verschiedene Aspekte von Daten zu bewerten, darunter Vollständigkeit, Gültigkeit, Zuverlässigkeit der Quellen, Konsistenz, Aktualität und zweisprachige Unterstützung. ",
    CompanyDQIdesc2:
      "Der Index soll die Qualität von Daten auf einer Skala von 1 bis 100 bewerten, wobei höhere Werte auf eine bessere Datenqualität hinweisen. Algorithmen können Daten anhand vordefinierter Regeln oder Kriterien analysieren und so objektive und standardisierte Messungen ermöglichen. ",
    CompanyDQIdesc3:
      "Als verlässlicher Indikator dient unser Data Quality Index (DQI), der Nutzern eine quantitative Beurteilung der Datenqualität ermöglicht. Dies ermöglicht eine datengesteuerte Entscheidungsfindung und erhöht den Gesamtwert und Nutzen der Daten.",
    CountryDQIdesc1:
      "Der Data Quality Index (DQI) bewertet die Zuverlässigkeit, Genauigkeit und Zugänglichkeit von Daten in verschiedenen Ländern und spiegelt Unterschiede in der digitalen Infrastruktur, Governance und Transparenz wider. Industrieländer rangieren in der Regel aufgrund starker Datensysteme, offener Richtlinien und fortschrittlicher Technologie höher, während Entwicklungsländer oft mit Lücken in der Infrastruktur, Regulierung oder Datenaustauschpraktiken zu kämpfen haben. ",
    CountryDQIdesc2:
      "Zu den Schlüsselfaktoren gehören die Transparenz der Regierung, Datenschutzgesetze und die Einführung neuer Technologien. Ein hoher DQI ermöglicht bessere politische und geschäftliche Entscheidungen, während ein niedriger Wert Bereiche hervorhebt, in denen Investitionen erforderlich sind.",
    CompanyDQI: "Firmen-DQI",
    CountryDQI: "Länder-DQI",
    CompanyTitle: "Datenqualitätsindex (DQI) nach Unternehmen",
    CountryTitle: "Datenqualitätsindex (DQI) nach Ländern",
    Address: "Adresse", //地址
    CountyCity: "Landkreis/Stadt", //县/市
    ProvinceState: "Provinz/Bundesland", //省/州
    CountryRegion: "Land/Region", //国家/地区
    ZipCode: "Postleitzahl", //邮政编码
    Website: "Website", //网站
    Email: "E-Mail", //电邮
    Tel: "Tel.", //电话
    LastUpdate: "Letzte Aktualisierung", //最近更新
    DataSource: "Datenquelle", //数据来源
    LegalStatus: "Rechtsform", //法定状况
    CoID: "Firmen-ID", //公司ID
    CompanyType: "Firmentyp", //公司类型
    RegistrationDate: "Registrierungsdatum", //注册日期
    RegistrationStatus: "Registrierungsstatus", //注册状态
    Listed: "Börsennotiert", //上市信息
    CurrentOpperations: "Aktuelle Geschäftstätigkeit", //经营状况
    IndustryCode: "Branchencode", //行业代码
    BusinessActivities: "Geschäftstätigkeit", //主营业务
    NoofEmployees: "Anzahl der Mitarbeiter", //员工数量
    NoofShareholders: "Anzahl der Aktionäre", //股东数量
    Management: "Management", //管理状况
    Performance: "Leistung", //业绩表现
    Revenue: "Umsatz", //收入
    Assets: "Vermögen", //资产
    ProfitLoss: "Gewinn/Verlust", //利润
    Growth: "Wachstum", //公司增长
    Competitiveness: "Wettbewerbsfähigkeit", //竞争力
    CreditOpinion: "Kreditauskunft", //信用状况
    CreditRating: "Kreditrating", //信用评级
    CreditScore: "Kredit-Score", //信用评分
    ESGRating: "ESG-Rating", //ESG 评级
    Solvency: "Solvenz", //偿还能力
    Sanctions: "Sanktionen", //全球制裁
    CoName: "Firmenname",
    RegName: "Registrierter Name",
  },
  Profile: {
    CompareCompanies: "Vergleichen Sie Unternehmen",
    AddaCompany: "Fügen Sie ein Unternehmen hinzu",
    SubjectCompany: "das betroffene Unternehmen", //目标公司
    ComparisonCompany: "Vergleichsunternehmen",
    CompanyProfile: "Firmenprofil", //基本资料
    CompanyName: "Firmenname", //公司名称
    NativeName: "Originelle Firmenname", //当地名称
    CompanyID: "Firmen-ID", //公司 ID
    VATNumber: "Umsatzsteuer-Identifikationsnummer", //VAT号
    StockCode: "Aktiencode", //股票代码
    Listed: "Börsennotiert", //上市日期
    RegistrationDate: "Registrierungsdatum", //注册日期
    LegalForm: "Rechtsform", //公司性质
    CompanyType: "Unternehmensart", //公司类型
    LegalStatus: "Rechtsstatus", //注册状态
    Jurisdiction: "Gerichtsbarkeit", //司法管辖区
    RegisteredAddress: "Registrierte Adresse", //注册地址
    ProvinceState: "Provinz/Bundesland", //省/州
    CountryRegion: "Land/Region", //国家/地区
    ZipCode: "Postleitzahl", //邮政编码
    OperatingAddress: "Geschäftsadresse", //经营地址
    LastUpdate: "Letzte Aktualisierung", //最近更新
    DataSource: "Datenquelle", //数据来源
    History: "Historie", //历史记录
    RegisteredCapital: "Eingetragenes Kapital",
    PaidinCapital: "Eingezahltes Kapital",
    CountyCity: "Landkreis/Stadt",
    OtherName: "Anderer Name",
  },
  Ownership: {
    TotalPartiesInvolved: "Gesamtzahl der beteiligten Parteien",
    UltimateBeneficiaryOwner: "Endgültiger wirtschaftlicher Eigentümer (UBO)", //最终受益人
    NaturalPersonShareholder: "Natürliche Person Aktionär",
    CorporateShareholders: "Unternehmensaktionäre", //涉及法人股东
    ShareholderLevel: "Gesellschafterebene", //股东层级x
    Name: "Name", //名称
    Country: "Land", //国家/地区
    Location: "Standort", //地点
    Type: "Art", //类型
    Shares: "Aktien", //股份
    Relation: "Verhältnis", //关系
    RelatedCompany: "Verwandte Unternehmen",
    CompanyShareholders: "Gesellschafter des Unternehmens",
    NGOShareholders: "NGO-Aktionäre",
    SubjectInvestments: "Investitionen des Subjekts",
  },
  RelatedCompanies: {
    Total: "Gesamtzahl der Einheiten", //相关公司总计
    Countries: "Länder", //国家/地区
    Branches: "Niederlassungen", //分支机构
    RelatedComp: "Verbundene Unternehmen", //关联公司
    Name: "Name", //名称
    Country: "Land", //国家/地区
    Location: "Standort", //地点
    Type: "Art", //类型
    Relationship: "Beziehung", //关系
    BranchOffices: "Niederlassungen",
    Subsidiaries: "Tochtergesellschaften",
  },
  Management: {
    Management: "Management", //管理层
    ContactInfo: "Kontaktinformationen", //联系人信息
    Countries: "Länder", //国家/地区
    Name: "Name", //名称
    Position: "Position", //职位
    Department: "Abteilung", //部门
    Country: "Land", //国家/地区
    ShareholderNot: "Aktionär oder nicht", //是否股东
    Relation: "Beziehungen", //关系
    Verification: "Verifizierung", //已验证
    Searchmoreemails: "Weitere E-Mails suchen", //搜索更多电邮
    Roles: "Rollen", //角色
    EducationLevel: "Bildungsniveau", //教育程度
    Phone: "Telefon", //电话
    Email: "E-Mail", //电邮
    Verified: "Verifiziert", //已验证
    Searchmore: "Weitere E-Mails anderer Unternehmen suchen", //搜索更多其他公司的电邮
    Pleaseentername: "Bitte Namen eingeben",
    PleaseenterWebsite: "Bitte geben Sie den Firmennamen oder die Domain ein.",
    UserSelfVerification: "Selbstverifizierung des Benutzers",
    Userverified: "Benutzer verifiziert",
    Source: "Quelle",
  },
  Operations: {
    LineofBusiness: "Geschäftszweig", //业务范围
    BusinessTerritories: "Geschäftsgebiete", //业务区域
    ImportExport: "Import & Export", //进出口信息
    Viewtradeinfo: "Weitere Handelsinformationen anzeigen", //查看更多贸易信息
    ProductsServices: "Produkte/Dienstleistungen", //产品/服务
    Products: "Produkte", //产品
    ProductImage: "Produktbild", //产品图片
    ProductName: "Produktname", //产品名称
    ProductDescription: "Produktbeschreibung", //产品描述
    Details: "Details", //详情
    Addproductinformation: "Produktinformationen hinzufügen", //添加产品信息
    Showcaseyourcompany:
      "Wenn Sie die Produkte oder Dienstleistungen Ihres Unternehmens der Öffentlichkeit präsentieren möchten, können Sie hier Ihre Produkt- und Serviceinformationen hinzufügen. Dies ist eine großartige Möglichkeit, Ihr Unternehmen zu fördern. Sobald wir Ihre Eingabe geprüft haben, werden Ihre Daten veröffentlicht.",
  },
  Locations: {
    CoName: "Firmenname", //业务范围
    Relationship: "Beziehung", //关系
    Type: "Art",
    Country: "Land", //国家/地区
    Location: "Standort", //地点
    Address: "Adresse", //地址
    Edit: "Bearbeiten", //编辑
    CompanyLocatiionsMap: "Firmenstandorte auf Karte", //地图中的公司位置
    Selectaddresstype: "Adresstyp auswählen", //选择地址类型
    Subjectcompany: "Unternehmen", //目标公司
    Subsidiary: "Tochtergesellschaft", //子公司
    RegisteredAddress: "Eingetragene Adresse", //注册地址
    OperationAddress: "Betriebsadresse", //运营地址
    All: "Alle", //全部
    Showlocation: "Standorte anzeigen",
  },
  Industry: {
    IndustryTitle: "Branchenbezeichnung", //IndustryTitle
    IndustryDescription: "Branchenbeschreibung", //IndustryDescription
    ISIC: "ISIC", //ISIC
    ISICDescription: "ISIC-Beschreibung", //ISICDescription
    NACE: "NACE", //NACEDescription
    NACEDescription: "NACE-Beschreibung", //NACEDescription
    NAICS: "NAICS", //NAICS
    NAICSDescription: "NAICS-Beschreibung", //NAICSDescription
    CSIC: "CSIC", //CSIC,
    CSICDescription: "CSIC-Beschreibung", //CSICDescription
    AAAIC: "AAAIC", //AAAIC
    AAAICDescription: "AAAIC-Beschreibung", //AAAICDescription
    GICS: "GICS", //GICS
    GICSDescriptio: "GICS-Beschreibung", //GICS 描述
  },
  ImportExport: {
    TotalImportAmount: "Gesamtimportmenge", //进口总额
    TopImportCountry: "Hauptimportland", //最大进口国家/地区
    TopImportProduct: "Hauptimportprodukt", //最大进口产品
    TotalExport: "Gesamtexportbetrag", //出口总额
    TopExportCountry: "Hauptexportland", //最大出口国家/地区
    TopExportProduct: "Hauptexportprodukt", //最大出口产品
    TradeVolume: "Handelsvolumen", //贸易额
    ImportShipments: "Importsendungen", //进口量
    ExportShipments: "Exportsendungen", //出口量
    ImportCountries: "Importländer", //进口国家/地区
    ExportCountries: "Exportländer", //出口国家/地区
    ImportVolume: "Importvolumen", //进口量
    ExportVolume: "Exportvolumen", //出口量
    Suppliers: "Hauptlieferanten", //主要供应商
    Shipments: "Nach Anzahl der Sendungen", //按出货量
    Buyers: "Hauptkäufer", //主要买家
    ImportQuantity: "Importmenge", //进口数量
    IncreaseDecreasexRate: "Zunahme-/Abnahmerate", //增/减率
    ExportQuantity: "Exportmenge", //出口数量
    ImportsExportsRecords: "Import- und Exportaufzeichnungen", //进出口记录
    Date: "Datum", //日期
    Product: "Produkt", //产品
    HSCode: "HS-Code", //HS 编码
    BuyerName: "Käufername", //买家名称
    Destination: "Bestimmungsort", //目的地
    SupplierName: "Lieferantname", //供应商名称
    Origin: "Herkunft", //原产地
    Amount: "Betrag (USD)", //金额
    Details: "Details", //详情
    Imports: "Importe",
    Exports: "Exporte",
    Shipments2: "Sendungen",
    value2: "Wert",
    value: "Nach Anzahl des Werts",
    viewmoretradeinfo: "Weitere Handelsinformationen anzeigen",
    SearchHSCode: "HS-Code suchen",
    Selectdate: "Datum auswählen",
  },
  SupplyChain: {
    Illustratesthesubjectcompany:
      "Dieses Diagramm veranschaulicht die „Kauf-von“- und „Verkauf-an“-Beziehungen des jeweiligen Unternehmens. Je größer das Volumen, desto dicker das Rohr.",
  },
  ShippingOrderDetails: {
    Date: "Datum",
    MasterBillofLading: "Master-Ladeschein",
    Source: "Quelle",
    BillNo: "Ladescheinnummer",
    ImporterBuyer: "Importeur/Käufer",
    ExporterSeller: "Exporteur/Verkäufer",
    Name: "Name",
    Address: "Adresse",
    Country: "Land",
    Contact: "Kontakt",
    Email: "E-Mail",
    CargoInfo: "Frachtinformationen",
    HSCode: "HS-Code",
    Quantity: "Menge",
    WeightUnit: "Gewichtseinheit",
    ProductDescription: "Produktbeschreibung",
    Amount: "Betrag (USD)",
    QuantityUnit: "Mengeneinheit",
    Weight: "Gewicht",
    HSDescription: "HS-Bezeichnung",
    Incoterms: "Incoterms",
    ShippingInfo: "Versandinformationen",
    Vessel: "Schiff",
    Consignee: "Empfänger",
    MeansofTransport: "Transportmittel",
    CountryofOrigin: "Ursprungsland",
    Voyage: "Reise",
    Notifier: "Melder",
    CountryofDestnation: "Bestimmungsland",
    AddressofOrigin: "Ursprungsadresse",
    Shipper: "Versender",
    AddressofDestnation: "Bestimmungsadresse",
    Container: "Container",
    ContainerID: "Container-ID",
    ContainerType: "Containertyp",
    ContainerDescDode: "Containerbeschreibung",
    ContainerSize: "Containergröße",
    ImportExport: "Importeur / Exporteur",
    Imports: "Importe",
    Exports: "Exporte",
  },
  FinancialHighlight: {
    Revenue: "Umsatz", //收入
    Profit: "Gewinn", //利润
    Growth: "Wachstum", //增长
    CashFlowStatus: "Cashflow-Status", //现金流状况
    FinancialStructure: "Finanzstruktur", //融资结构
    CreditOpinion: "Kreditbewertung", //信用评估
    RiskIndicator: "Risikoindikator", //风险指标
    Solvencyindex: "Bonitätsindex", //偿还指数
    Year: "Jahr", //年份
    Change: "Veränderung", //变化
    NetProfit: "Nettogewinn",
    TotalAssets: "Bilanzsumme",
    Equity: "Eigenkapital",
    GrossMargin: "Bruttomarge",
    ProfitMargin: "Gewinnspanne",
    ReturnonEquity: "Eigenkapitalrendite",
    CurrentRatio: "Aktuelle Kennzahl",
    DebtRatio: "Verschuldungsgrad",
    FinancialHighlights: "Finanzdaten der verbundenen Unternehmen", //关联公司财务数据
    FinancialHighlightsTitle:
      "Finanzielle Highlights der verbundenen Unternehmen", //关联公司财务摘要
    CompanyName: "Firmenname", //公司名称
    CompanyID: "Firmen-ID", //公司ID
    Country: "Land", //国家/地区
    CompanyStatus: "Firmenstatus", //公司状态
    Cancel: "Abbrechen", //取消
    Select: "Auswählen",
    Relations: "Beziehungen", //关系
    Financialperformancedata:
      "Finanzielle Leistungsdaten werden von verschiedenen staatlichen Quellen und lokalen Kreditauskunfteien gesammelt. Darüber hinaus werden Markt- und Branchenforschung zur Berechnung und Modellierung der Daten herangezogen. Für detailliertere Informationen zum tatsächlichen Betrieb und zur Leistungsanalyse wenden Sie sich bitte an unser Serviceteam, um einen Unternehmens-Due-Diligence-Bericht anzufordern.",
    Whenthesubjectsdata:
      "Wenn die Daten des Subjekts nicht ausreichen oder Sie daran interessiert sind, mehr Einblicke in Ihre Kunden zu gewinnen, bietet diese Plattform einen umfassenden Überblick über alle mit dem Subjekt verbundenen Unternehmen. Dazu gehören die Aktionäre des Subjekts, verbundene Unternehmen und mehr.",
    Byprovidingyou:
      "Durch die Bereitstellung einer breiteren Perspektive ermöglicht Ihnen diese Plattform fundiertere Bewertungen und ein tieferes Verständnis Ihres Themas. ",
    PleaseSelectTheYeartoDisplay: "Bitte wählen Sie das anzuzeigende Jahr aus",
    SelectUptoThreeYears: "Wählen Sie Bis zu drei Jahre aus",
  },
  RatioAnalysis: {
    ProfitabilityRatios: "Rentabilitätskennzahlen",
    Year: "Jahr",
    Change: "Veränderung",
    Returnonequity: "Eigenkapitalrendite",
    Returnonassets: "Gesamtrendite",
    Profitmargin: "Gewinnspanne",
    Grossmargin: "Bruttomarge",
    OperatingRatios: "Betriebskennzahlen",
    Assetsturnover: "Kapitalumschlag",
    Stockturnover: "Lagerumschlag",
    Salesperiod: "Verkaufszeitraum",
    Collectionperiod: "Inkassozeitraum",
    Creditperiod: "Kreditlaufzeit",
    StructuralRatios: "Strukturkennzahlen",
    Currentratio: "Aktuelle Kennzahl",
    Quickratio: "Schnellverhältnis",
    Shareholdersliquidityratio: "Liquiditätsquote",
    Solvencyratio: "Solvenzquote",
    Debtratio: "Verschuldungsgrad",
    ProductivityRatios: "Produktivitätskennzahlen",
    Profitperemployee: "Gewinn pro Mitarbeiter",
    Operatingrevenueperemployee: "Betriebsertrag pro Mitarbeiter",
    Shareholdersfundsperemployee: "Eigenkapital pro Mitarbeiter",
    Totalassetsperemployee: "Bilanzsumme pro Mitarbeiter",
    GrowthRatios: "Wachstumskennzahlen",
    Salesgrowthrate: "Umsatzwachstumsrate",
    Netprofitgrowthrate: "Nettogewinnwachstumsrate",
    Totalassetsgrowthrate: "Bilanzwachstumsrate",
    FinancialHighlights: "Finanzdaten der verbundenen Unternehmen", //关联公司财务数据
    RatioAnalysis: "Kennzahlenanalyse der verbundenen Unternehmen", //关联公司比率分析
    CompanyName: "Firmenname",
    CompanyID: "Firmen-ID",
    Country: "Land",
    CompanyStatus: "Firmenstatus",
    Relations: "Beziehungen",
  },
  IndustryNorms: {
    IndustryStatistics: "Branchenstatistik",
    ofcompaniesintheIndustry: "Anzahl der Unternehmen in der Branche",
    oflistedCompaniesintheIndustry:
      "Anzahl der börsennotierten Unternehmen in der Branche",
    oflargecompaniesintheIndustry: "Anzahl der Großunternehmen in der Branche",
    ofSMEsintheIndustry: "Anzahl der KMU in der Branche",
    ofcompaniesinsample: "Anzahl der Unternehmen in der Stichprobe",
    ofcompaniesinloss: "Anzahl der Unternehmen mit Verlust",
    Observations: "Beobachtungen",
    AverageValue: "Durchschnittswert",
    MedianValue: "Medianwert",
    MaximumValue10: "Maximalwert 10 %",
    MinimumValue10: "Minimalwert 10 %",
    SubjectCompany: "Betroffenes Unternehmen",
    YearsinBusiness: "Geschäftsjahre",
    TotalAssets: "Bilanzsumme",
    TotalEquity: "Eigenkapital",
    Revenue: "Umsatz",
    NetEarning: "Nettogewinn",
    Returnonassets: "Kapitalrendite",
    Performance: "Leistung",
    ProfitabilityRatios: "Rentabilitätskennzahlen",
    Returnonequity: "Eigenkapitalrendite",
    Grossmargin: "Bruttogewinnspanne",
    OperatingRatios: "Betriebskennzahlen",
    Stockturnover: "Lagerumschlag",
    Accountsreceivableturnover: "Debitorenumschlag",
    Assetsturnover: "Vermögensumschlag",
    Totalassetturnover: "Gesamtvermögensumschlag",
    StructuralRatios: "Strukturkennzahlen",
    Currentratio: "Aktuelle Kennzahl",
    Quickratio: "Quick ratio",
    Shareholdersliquidityratio: "Liquiditätsquote",
    GrowthRatios: "Wachstumskennzahlen",
    Salesgrowthrate: "Umsatzwachstumsrate",
    Netprofitgrowthrate: "Nettogewinnwachstumsrate",
    Totalassetsgrowthrate: "Bilanzwachstumsrate",
  },
  Lawsutis: {
    Litigations: "Litigations",
    Date: "Datum",
    CaseType: "Fall Typ",
    Title: "Falltitel",
    CaseNo: "Fall Nr.",
    CauseofAction: "Klagegrund",
  },
  News: {
    Date: "Datum", //日期
    Title: "Titel", //标题
    Source: "Quelle", //来源
    Impact: "Auswirkung", //影响
    Searchcompanies: "Weitere Nachrichten zu anderen Unternehmen suchen", //国家/地区
    SearchforTitle: "Titelsuche",
    CompanyName: "Firmenname",
    Industry: "Industrie",
    Subjects: "Themen",
    NewsTypes: "Nachrichtentypen",
    ByDate: "Nach Datum",
    SelectCompanyName: "Firmenname auswählen",
    SelectIndustry: "Wählen Sie Branche aus",
    SelectSubjects: "Fächer auswählen",
    SelectNewsType: "Nachrichtentyp auswählen",
    Negative: "Negativ",
    Positive: "Positiv",
  },
  Sanctions: {
    Potentialcompliance: "Es wurden potenzielle Compliance-Risiken erkannt.", //检测到潜在合规风险
    SeachbuttonNo:
      "Es wurden keine negativen Auswirkungen auf dieses Unternehmen festgestellt.", //未检测到任何与该公司相关的不良记录
    SeachbuttonYes:
      "Um weitere Sanktionsaufzeichnungen zu suchen, klicken Sie bitte auf „Sanktionen suchen“.", //要搜索更多制裁记录，请点击“搜索制裁”按钮。
    SearchSanctions: "Sanktionen suchen", //搜索制裁
    ViewDetails: "Details anzeigen", //查看详情
    Sanctions: "Sanktionen", //制裁
    Potentialcompliancerisks: "Potenzielle Compliance-Risiken", //潜在合规风险
    IDInfo: "ID-Informationen", //ID 信息
    IDType: "ID-Typ", //ID 类型
    IDDescription: "ID-Beschreibung", //ID 描述
    SanctionList: "Sanktionsliste", //制裁名单
    SanctionListInvolved: "Betroffene Sanktionsliste", //涉及的制裁名单
    StartDate: "Startdatum", //生效日期
    EndDate: "Enddatum", //结束日期
    SourceList: "Quellenliste", //来源名单
    SourceName: "Quellenname", //来源名称
    ProfileNotes: "Profilnotizen", //主体资料
    Link: "Link", //链接
    Name: "Name", //名称
    AssociationList: "Verbandsliste",
    AssociationID: "Vereins-ID",
    AssociationType: "Assoziationstyp",
  },
  CreditOpinion: {
    CreditAssessment: "Bonitätsprüfung",
    CreditAssessmentfromtheRelatedCompanies:
      "Bonitätsprüfung der verbundenen Unternehmen",
    Year: "Jahr",
    CreditRating: "Bonitätsrating",
    LocalCreditScore: "Lokale Bonitätsbewertung",
    ProbabilityofDefault: "Ausfallwahrscheinlichkeit",
    SolvencyIndex: "Bonitätsindex",
    CreditLine: "Kreditrahmen",
    RiskIndicator: "Risikoindikator",
    RelatedCreditAssessment: "Verwandte Bonitätsprüfung",
    CompanyName: "Firmenname",
    CompanyID: "Firmen-ID",
    Country: "Land",
    CompanyStatus: "Firmenstatus",
    Relations: "Beziehungen",
    Cancel: "Abbrechen", //取消
    Select: "Auswählen",
    CreditAssessmentMessage1:
      "Wenn die Daten des Subjekts nicht ausreichen oder Sie daran interessiert sind, mehr Einblicke in Ihre Kunden zu gewinnen, bietet diese Plattform einen umfassenden Überblick über alle mit dem Subjekt verbundenen Unternehmen. Dazu gehören die Aktionäre des Subjekts, verbundene Unternehmen und mehr.",
    CreditAssessmentMessage2:
      "Durch die Bereitstellung einer breiteren Perspektive ermöglicht Ihnen diese Plattform fundiertere Bewertungen und ein tieferes Verständnis Ihres Themas.",
    LocalCreditRating: "Lokale Bonitätsbewertung",
    LocalCreditRatingDetail:
      "Angetrieben durch die Macht von Big Data ist 3ARating ein quantitatives Bewertungssystem für Privatunternehmen. Es handelt sich um eine Zusammenarbeit zwischen 3ACredit und Creditreform Rating. Das Ratingmodell basiert auf einer umfassenden Bewertung verschiedener Schlüsselfaktoren, einschließlich nichtfinanzieller Faktoren, finanzieller Faktoren, negativer Aufzeichnungen und branchenspezifischer Überlegungen. Das Bewertungsmodell weist einen beeindruckenden Gini-Koeffizienten auf, der auf seine Robustheit und Zuverlässigkeit hinweist. 3ARating umfasst eine Reihe von Bewertungen, von der höchsten Bewertung, 3A1, bis zur niedrigsten Bewertungsklasse, 3A19.",
    CreditScore: "Kreditwürdigkeit",
    CreditScoreDetail:
      "Der Kredit-Score wird auf einer Skala von 1 bis 100 berechnet, basierend auf der Bonitätsbewertung der örtlichen Behörden. Ein höherer Score weist auf eine bessere Kreditwürdigkeit hin.",
    PossibilityofDefault: "Möglichkeit des Zahlungsausfalls (PD)",
    PossibilityofDefaultDetail:
      "Die Ausfallmöglichkeit (PD) ist ein nützliches Instrument zur Risikobewertung, das sich auf die kurzfristige Liquiditätsbewertung konzentriert.",
    SolvencyIndexSI: "Solvenzindex (SI)",
    SolvencyIndexSIDetail:
      "Der Solvabilitätsindex (SI) ist ein hochwirksamer und zuverlässiger Frühwarnindikator, der eine schnelle Einschätzung der Zahlungsfähigkeit von Geschäftspartnern ermöglicht. Ein höherer SI-Wert weist auf ein höheres Ausfallrisiko eines Kunden hin. Der SI reicht von 100, was als ausgezeichnete Bewertung gilt, bis 600, wo stark negative Eigenschaften vorhanden sind.",
    ExternalRating: "Externe Bewertung",
    DefaultProbability: "Standardwahrscheinlichkeit (Pd1Jahr)",
    Rating: "3ARBewertung (>=,<=)",
    PleaseSelectTheYeartoDisplay: "Bitte wählen Sie das anzuzeigende Jahr aus",
    SelectUptoThreeYears: "Wählen Sie Bis zu drei Jahre aus",
    HighRisk: "Hohes Risiko",
    Medium: "Medium",
    Moderate: "Mäßig",
    Average: "Durchschnitt",
    LowerThanAvg: "Unter dem Durchschnitt",
    LowRisk: "Niedriges Risiko",
    CreditOpinion: "Kreditbeurteilung",
  },
  IndustryStatistics: {
    SubjectCompany: "Betreff Unternehmen",
    Country: "Land",
    Compare: "Vergleichen",
    Industry: "Branche",
    CompanyType: "Unternehmenstyp",
    CompanySize: "Unternehmensgröße",
    CompanyStatus: "Unternehmensstatus",
    YearsinBusiness: "Geschäftsdauer",
    CompanyRating: "Unternehmensbewertung",
    Liquidity: "Liquidität",
    NoofcoinIndustry: "Anzahl der Co. in der Industrie",
    IndustryRating: "Branchenbewertung",
    Profitability: "Rentabilität",
    Growth: "Wachstumskennzahlen",
    FinancialStructurt: "Finanzstruktur",
    Solvency: "Solvency",
    SearchCountry: "Land suchen",
  },
  RatingAnalysis: {
    IndustyAnalysis: "Branchenanalyse",
    GeographicAnalysis: "Geografische Analyse",
    CompanyTypeAnalysis: "Unternehmenstypanalyse",
    BiusinessScaleAnalysis: "Skalenanalyse",
    HistoryAnalysis: "Historische Analyse",
    NormalDistribution: "Normalverteilung",
    SubjectCompany: "Unternehmen",
    Probabilityofthesubjectratinginitsindustry:
      "Wahrscheinlichkeit der Bewertung des Unternehmens in seiner Branche",
    Maximum: "Maximal 10 %",
    Mean: "Mittelwert",
    Average: "Durchschnitt",
    Minimum: "Minimum 10 %",
    RatingDistribution: "Bewertungsverteilung",
    Revenue: "Umsatz",
    Earning: "Ertrag",
    TotalAssets: "Bilanzsumme",
    Subjectratinginitsindustrybyfinancialindicators:
      "Bewertung des Unternehmens in seiner Branche nach Finanzkennzahlen",
    Best: "Beste",
    Worst: "Schlechteste",
    Rankingofsubject: "Ranking der Bewertung des Unternehmens in der Branche",
    Industy: "Branche",
    Percentilerank:
      "Perzentilrang: Prozentsatz der Unternehmen, die die Bewertung des Unternehmens erreicht oder unterschritten haben",
    Historicaldevelopmentofsubject:
      "Historische Entwicklung der Bewertung des Unternehmens in seiner Branche",
    IndustryAverage: "Branchendurchschnitt",
    SubjectRatingChanges: "Änderungen der Bewertung des Unternehmens",
    CreditScore: "Kreditwürdigkeit",
    NOofCompanies: "Anzahl der Unternehmen",
    ofCompanies: "% der Unternehmen",
    CreditRating: "Bonitätsbewertung",
    CompanySize: "Unternehmensgröße",
    YearsinBusiness: "Geschäftsjahre",
    SubjectsIndustryConcentrationAnalysis:
      "Branchenkonzentrationsanalyse des Probanden",
    GeographicdistributionofSubjectsratingintsindustry:
      "Geografische Verteilung der Bewertung des Subjekts in seiner Branche",
    GeographicdistributioninSubjectindustry:
      "Geografische Verteilung in der Branche des Subjekts",
    RatingDistributioninSubjectsLocation:
      "Bewertungsverteilung am Standort des Probanden",
    Ratinganalysisofcompanies:
      "Ratinganalyse von Unternehmen der gleichen Branche mit unterschiedlicher Geschäftstätigkeit",
    Subjectsratinghistory:
      "Der Bewertungsverlauf des Probanden im Vergleich zu seinen Kollegen mit demselben Verlauf",
    Ratingrankingofcompanieswithsamehistory:
      "Rating-Ranking von Unternehmen mit gleicher Geschichte",
    Ratingstatistics:
      "Ratingstatistik von Unternehmen mit den gleichen Geschäftsjahren",
    Subjectratingcomparing:
      "Themenbewertung im Vergleich zu seinen Vergleichsunternehmen mit dem",
    Subjectratinginitsgroup: "Fachbewertung in seiner Gruppe",
    Analysisbasedonnature:
      "Analyse basierend auf der Art der Unternehmen in der betreffenden Branche",
    Subjectratingpositioninitscompanytype:
      "Betreffbewertungsposition in seiner Unternehmensart",
    Ratingstatisticsofcompanies:
      "Bewertungsstatistik von Unternehmen derselben Branche",
    Ratinganalysisofcompanies:
      "Ratinganalyse von Unternehmen unterschiedlicher Größe in derselben Branche",
    Probabilityofsubjectrating:
      "Wahrscheinlichkeit einer Fachbewertung in seiner Branche innerhalb seiner Größe",
    Subjectratingcomparingwithindustry:
      "Themenbewertung im Vergleich zu Branchenkollegen",
    RatingRankingofthecompanies:
      "Rating Ranking der Unternehmen gleicher Größe in der gleichen Branche",
    Ratingstatisticsofcompanies:
      "Ratingstatistik von Unternehmen gleicher Größe und gleicher Branche",
    Rank: "Rang",
    Rating: "Rating",
    CompanyType: "Unternehmenstyp",
  },
  CompetitiveAnalysis: {
    MarketPosition: "Marktposition",
    Revenus: "Umsatz",
    NetEarnings: "Nettogewinn",
    NetAssets: "Nettovermögen",
    TotalAssets: "Gesamtvermögen",
    Employees: "Mitarbeiter",
    Mean: "Mittelwert",
    Average: "Durchschnitt",
    Maximum: "Maximum (10 %)",
    Worst: "Schlechtestes (10 %)",
    Subjectcompany: "Vergleichsunternehmen",
    PerformanceComparison: "Leistungsvergleich",
    ProfitabilityRatios: "Rentabilitätskennzahlen",
    Grossmargin: "Bruttomarge",
    Returnonassets: "Kapitalrendite",
    Returnonequity: "Eigenkapitalrendite",
    OperatingRatios: "Betriebskennzahlen",
    Stockturnover: "Lagerumschlag",
    Assetsturnover: "Kapitalumschlag",
    Currentassetturnoverrate: "Aktuelle Vermögensumsatzquote",
    Collectionperiod: "Erfassungszeitraum",
    GrowthRatios: "Wachstumskennzahlen",
    Totalassetsgrowthrate: "Wachstumsrate des Gesamtvermögens",
    Salesgrowthrate: "Umsatzwachstumsrate",
    Netprofitgrowthrate: "Wachstumsrate des Nettogewinns",
    StructuralRatios: "Strukturkennzahlen",
    Debtratio: "Verschuldungsgrad",
    Quickratio: "Quick ratio",
    Currentratio: "Aktuelle Kennzahl",
  },
  AccountCenterMenu: {
    SearchinSettings: "Suche in den Einstellungen", //在“设置”中搜索
    Account: "Konto", //账户
    MyAccount: "Mein Konto", //我的账户
    ContactInfo: "Kontaktdaten", //联系信息
    AccountSecurity: "Kontosicherheit", //账户安全
    OrganizationalManagement: "Organisationsverwaltung", //组织管理
    UserGroup: "Benutzergruppe", //用户组
    User: "Benutzergruppe", //用户
    Role: "Rolle", //角色
    MyDatabase: "Meine Datenbank", //我的数据库
    MyUsage: "Meine Nutzung", //我的使用情况
    CompaniesViewed: "Angesehene Unternehmen", //查看过的公司
    ReportsDownloaded: "Heruntergeladene Berichte", //下载的报告
    ReportUpdatesOrdered: "Bestellte Berichtsaktualisierungen", //订购的报告更新
    BillingandPayment: "Rechnungsdatensätze", //账单和付款
    BillRecords: "Rechnungsdatensätze", //账单记录
    PaymentRecords: "Zahlungsdatensätze", //付款记录
    CreditDeductions: "Gutschriften", //信用扣款
    InvoicesDownloaded: "Heruntergeladene Rechnungen", //下载的发票
    UserSettings: "Benutzereinstellungen", //用户设置
    Messages: "Nachrichten", //消息
    Notifications: "Benachrichtigungen", //通知
    HelpCenter: "Hilfe", //帮助中心
    FAQ: "FAQ", //常见问题
    Privacy: "Datenschutz", //隐私
    Terms: "Nutzungsbedingungen", //条款
    ReportIssues: "Probleme melden", //报告问题
    UserGuide: "Benutzerhandbuch", //用户指南
    AboutCSI: "Über CSI", //关于CSI
  },
  MyAccount: {
    Logintime: "Anmeldezeit", //登录时间
    SignOut: "Abmelden", //退出
    DeleteAccount: "Konto löschen", //删除账户
    AccountID: "Konto-ID", //账户ID
    Enteranewaddress: "Neue E-Mail-Adresse eingeben", //输入新的电邮
    EnterVerificationCode: "Bestätigungscode eingeben", //输入验证码
    SendverificationCode: "Bestätigungscode senden", //发送验证码
    Password: "Passwort", //密码
    Originalpassword: "Ursprüngliches Passwort", //原始密码
    Newpassword: "Neues Passwort", //新密码
    Confirmnewpassword: "Neues Passwort bestätigen", //确认新密码
    AccountOwnership: "Kontoinhaber", //账户所有权
    IndividualAccount: "Einzelkonto", //个人账户
    GroupAccount: "Gruppenkonto", //集团账户
    Organizationname: "Name der Organisation", //机构名称
    CountryRegion: "Land/Region", //国家/地区
    Address: "Adresse", //地址
    City: "Ort", //城市
    ZipCode: "Postleitzahl", //邮政编码
    FirstName: "Vorname", //名字
    LastName: "Nachname", //姓氏
    PhoneNumber: "Telefonnummer", //电话号码
    Email: "E-Mail", //更改
    Change: "Ändern", //更改
    Save: "Speichern", //保存
    Cancel: "Abbrechen", //取消
    LastLogin: "Letzte Anmeldung", //Last Login
    RecentLogin: "Letzte Anmeldung", //登录尝试次数
    AverageLoginTime: "Durchschnittliche Anmeldezeit", //平均登录时间
    TotalLoginAttempts: "Anmeldeversuche gesamt", //登录尝试次数
    Registrationtime: "Registrierungszeit",
    Role: "Rolle",
    Administrator: "Administrator",
    Enterpriseusers: "Unternehmensbenutzer",
    EditImage: "Bild bearbeiten",
    DeleteImage: "Bild löschen",
  },
  ContactInfo: {
    ContactInfo: "Kontaktinformationen",
    FirstName: "Vorname",
    LastName: "Nachname",
    PhoneNumber: "Telefonnummer",
    Email: "E-Mail",
    CountryRegion: "Land/Region",
    AddressLine: "Adresszeile",
    City: "Ort",
    ZipCode: "Postleitzahl",
    Alternativecontactperson: "Alternativer Ansprechpartner",
    Setascontactperson: "Als Ansprechpartner festlegen",
    Edit: "Bearbeiten",
  },
  AccountSecurity: {
    Setupmysecurityquestions: "Sicherheitsfragen einrichten",
    Pleasechooseaquestion: "Bitte wählen Sie eine Frage aus",
    Pleaseentertheanswertothequestion:
      "Bitte geben Sie die Antwort auf die Frage ein",
    SessionTimeoutAutomaticLogoutSettings:
      "Sitzungs-Timeout: Automatische Abmeldung",
    Thesystemwillautomatically:
      "Das System meldet Sie nach einer gewissen Zeit der Inaktivität automatisch ab. Die Standard-Timeout-Dauer beträgt 5 Minuten, Sie können diese jedoch nach Bedarf anpassen.",
  },
  MyDatabase: {
    TotalNumberofCompaniesSearched: "Gesamtzahl der gesuchten Unternehmen",
    TotalNumberofCompaniesCollected: "Gesamtzahl der erfassten Unternehmen",
    TotalNumberofUpdateReportsOrdered:
      "Gesamtzahl der bestellten Update-Berichte",
    Date: "Datum",
    UserName: "Benutzername",
    CompanyName: "Firmenname",
    Status: "Status",
    UsageType: "Nutzungsart",
    Entercompanyname: "Firmenname eingeben",
    Download: "Herunterladen",
  },
  OrganizationalManagement: {
    GroupName: "Gruppenname",
    ParentGroupName: "Name der übergeordneten Gruppe",
    Organization: "Organisation",
    GroupID: "Gruppen-ID",
    GroupStatus: "Gruppenstatus",
    Operation: "Operation",
    NewlyBuilt: "Neu erstellt",
    UserAccount: "Benutzerkonto",
    Role: "Rolle",
    AccountStatus: "Kontostatus",
    RoleName: "Rollenname",
    Position: "Position",
    RoleStatus: "Rollenstatus",
    Valid: "Gültig",
    Invalid: "Ungültig",
    PermissionSettings: "Berechtigungseinstellungen",
    ShowMore: "Mehr anzeigen",
    Search: "Suchen",
    Cancel: "Abbrechen",
    Confirm: "Bestätigen",
    NewGroup: "NeueGruppe",
    EnterGroupName: "Geben Sie den Gruppennamen ein",
    NumberofGroups: "Anzahl der Gruppen",
    Groups: "Groups",
    Roles: "Rollen",
    NewRoles: "Neue Rollen",
    EnterNewRole: "Geben Sie eine neue Rolle ein",
    Users: "Benutzer",
    EnterUserName: "Geben Sie den Benutzernamen ein",
  },
  BillingandPayment: {
    TotalNumberofOrders: "Gesamtzahl der Bestellungen",
    TotalPaymentAmount: "Gesamtzahlungsbetrag",
    TotalUsedCredits: "Gesamt genutzte Credits",
    Date: "Datum",
    UserAccount: "Benutzerkonto",
    CompanyName: "Firmenname",
    OrderNo: "Bestellnummer",
    OrderType: "Bestellart",
    OrderStatus: "Bestellstatus",
    Download: "Herunterladen",
    PaymentAmount: "Zahlungsbetrag",
    Contactus: "Kontakt",
    DownloadInvoice: "Rechnung herunterladen",
    CreditUsage: "Kreditnutzung",
    ReportOrderStatus: "Bestellstatus melden",
    CompanyID: "Firmennummer",
    CountryRegion: "Land/Region",
    AddressLine: "Adresszeile",
    City: "Ort",
    ZipCode: "Postleitzahl",
    FirstName: "Vorname",
    LastName: "Nachname",
    PhoneNumber: "Telefonnummer",
    Email: "E-Mail",
    BankAccountHolderName: "Kontoinhaber",
    BeneficiaryBankName: "Name der Empfängerbank",
    SWIFTCODE: "SWIFT-CODE",
    AccountNumber: "Kontonummer",
    BeneficiaryBankAddress: "Adresse der Empfängerbank",
    ABA: "ABA (Bankleitzahl)",
    IBANnumber: "IBAN-Nummer",
    StartingMonth: "Startmonat",
    EndMonth: "Endmonat",
    InvoiceInfo: "Rechnungsinformationen",
  },
  UserSettings: {
    LanguageandLocation: "Sprache und Standort",
    Language: "Sprache",
    Selectyourpreferedlanguage: "Wählen Sie Ihre bevorzugte Sprache",
    Location: "Standort",
    Selectyourlocation: "Wählen Sie Ihren Standort",
    NotificationSetting: "Benachrichtigungseinstellungen",
    EmailNotification: "E-Mail-Benachrichtigung",
    ServiceUpdates: "Service-Updates",
    CompanyNews: "Unternehmensnachrichten",
  },
  AddCredit: {
    Customizeyourplan: "Passen Sie Ihren Plan ganz nach Ihren Wünschen an",
    Silver: "Silber",
    Gold: "Gold",
    Enterpris: "Unternehmen",
    Credit: "Kredit",
    Remaining: "Verbleibende {0} Punkte",
    Usermonth: "Benutzer/Monat",
    Useryear: "Benutzer/Jahr",
    PaidMonthlyRenews:
      "Monatliche Zahlung, keine automatische Verlängerung erforderlich",
    PaidAnnuallyRenews:
      "Jährliche Zahlung, keine automatische Verlängerung erforderlich",
    ForFullSupport: "für die volle Unterstützung Ihrer Bedürfnisse",
    Each: "jeder",
    CreditsCharged:
      "Das Ihrem Konto belastete Guthaben verfällt niemals, solange Ihr Konto aktiv bleibt.",
    PaidMonthly: "monatlich bezahlt",
    PaidAnnually: "jährlich ausgezahlt",
    BuyNow: "Jetzt kaufen",
    ContactNow: "Kontaktieren Sie uns jetzt",
    SearchCompanies:
      "Durchsuchen Sie Unternehmen und erhalten Sie sofortigen Zugriff auf Unternehmensdaten, einschließlich:",
    EverythinginSilverPackage: "Alles im Silver-Paket, plus",
    CreditsCanbeUsed:
      "Credits können für weitere Datendienste verwendet werden, einschließlich der folgenden",
    UnlimitedAdvancedSearch: "Unbegrenzte erweiterte Suche",
    ViewCompanyProfile: "Firmenprofil ansehen",
    CompanyOwnershipStructure: "Eigentümerstruktur des Unternehmens",
    CompanyFamilyTree: "Stammbaum des Unternehmens",
    Companymanagement: "Unternehmensleitung",
    CompanyContactsinfo: "Kontaktdaten des Unternehmens",
    BusinessActivities: "Geschäftsaktivitäten",
    IndustryBasics: "Branchengrundlagen",
    ImportExportRecords: "Datensätze importieren und exportieren",
    CompanyPublications: "Unternehmenspublikationen",
    CompanyNews: "Unternehmensnachrichten",
    DownloadOnlineReport: "Online-Bericht herunterladen",
    ManagementDetails: "Verwaltungsdetails",
    ShareholderPenetration: "Aktionärsdurchdringung (UBO)",
    Financialinfo: "Finanzielle Informationen",
    FinancialAnalysis: "Finanzanalyse",
    CreditAssessment: "Bonitätsprüfung",
    IndustryAnalysis: "Branchenanalyse",
    MarketAnalysis: "Marktanalyse",
    SupplyChaininfo: "Informationen zur Lieferkette",
    CheckSanctions: "Sanktionen prüfen",
    CompanyComparison: "Firmenvergleich",
    DataExport: "Datenexport",
    MonitoringService: "Überwachungsdienst",
    DiscountForFreshUpdateReports: "Rabatt für neue Update-Berichte",
    SearchCompany: "Firma suchen",
    SearchLeads: "Suche nach Leads",
    SearchTrade: "Suche Handel",
    SearchPeople: "Personen suchen",
    SearchCountry: "Land suchen",
    SearchNews: "Suchen Sie nach Nachrichten",
    SearchSanction: "Durchsuchungssanktion",
    DataServices: "Datendienste",
    APIPlans: "API-Pläne",
    VolumeDiscounts: "Mengenrabatte",
    GroupAccountsWithMultipleUsers: "Gruppenkonten mit mehreren Benutzern",
    CustomizedPlans: "Maßgeschneiderte Pläne",
    FreshInvestigatedCreditReportsWorldwide:
      "Frisch recherchierte Kreditauskünfte weltweit",
    BusinessMonitoringServices: "Unternehmensüberwachungsdienste",
    BusinessProcessVerificationServices:
      "Dienstleistungen zur Überprüfung von Geschäftsprozessen",
    VendorComplianceReports: "Compliance-Berichte von Anbietern",
    MarketResearch: "Marktforschung",
    More: "Mehr…",
    Contactus: "Kontaktieren Sie uns",
    PaymentMethod: "Zahlungsmethode",
    CreditCardNumber: "Kreditkartennummer",
    EnterCardNumber: "Geben Sie die Kartennummer ein",
    ExpirationDate: "Ablaufdatum",
    Fullnameoncard: "Vollständiger Name auf der Karte",
    EnterFullname: "Geben Sie den vollständigen Namen ein",
    EnterProvinceState: "Geben Sie Provinz/Bundesland ein",
    CVCCode: "CVC-Code",
    EnterCVCCode: "Geben Sie den CVC-Code ein",
    TotalPurchase: "Gesamtkauf",
    Agree1: "Indem Sie auf „Senden“ klicken, stimmen Sie der",
    Agree2: "CSI-Dienstleistungsvereinbarung und dem Datenschutz zu.",
    Submit: "Senden",
    Month: "Monat",
    Year: "Jahr",
    Country: "Land",
    ProvinceState: "Provinz/Bundesland",
    Cancel: "Abbrechen",
    IncorrectCreditCardNumberformat: "Falsches Format der Kreditkartennummer",
    IncorrectExpMonthformat: "Falsches Exp.Month-Format",
    IncorrectExpYearformat: "Falsches Exp.Year-Format",
    IncorrectFullNameformat: "Falsches Format für den vollständigen Namen",
    IncorrectCountryformat: "Falsches Länderformat",
    IncorrectProvinceStateformat: "Falsches Provinz-/Staatsformat",
    IncorrectCVCCodeformat: "Falsches CVC-Codeformat",
  },
  ReportIssues: {
    Whattypeoferrorsyouarereporting: "Welche Art von Fehlern melden Sie?",
    Tellusmoreaboutyourproblems: "Erzählen Sie uns mehr über Ihre Probleme.",
    Wouldyouliketoprovideascreenshotorafileregardingyourproblem:
      "Möchten Sie einen Screenshot oder eine Datei zu Ihrem Problem bereitstellen?",
    Fillinyourcontactinformation: "Geben Sie Ihre Kontaktdaten ein:",
    FirstName: "Vorname",
    LastName: "Nachname",
    PhoneNumber: "Telefonnummer",
    Email: "E-Mail",
    Edit: "Bearbeiten",
  },
  //Risk Scan
  RiskScan: {
    RiskScan: "Risk Scan",
    RiskScanInfo:
      " ist Ihre Komplettlösung für umfassende Unternehmensrisikoanalysen. Wir bieten detaillierte Analysen aller wichtigen Risikokategorien, um Ihre Geschäftsentscheidungen abzusichern.",
    LegalRisk: "Rechtliches Risiko",
    LegalRiskInfo: "Überprüfen Sie die Legitimität des Unternehmens.",
    OrganizationalRisk: "Organisatorisches Risiko",
    OrganizationalRiskInfo:
      "Managementstabilität, Komplexität der Unternehmensstruktur und Transparenz der Eigentumsverhältnisse.",
    OperationalRisk: "Operatives Risiko",
    OperationalRiskInfo:
      "Schwachstellen in der Lieferkette, operativer Status und geopolitische Gefährdung.",
    FinancialRisk: "Finanzielles Risiko",
    FinancialPerformanceRiskInfo:
      "Rentabilitätstrends, Liquiditätsprobleme und Bilanzgesundheit.",
    CreditRisk: "Kreditrisiko",
    CreditRiskInfo:
      "Kreditwürdigkeit, Zahlungshistorie und Ausfallwahrscheinlichkeit.",
    ComplianceRisk: "Compliance-Risiko",
    ComplianceRiskInfo:
      "Einhaltung von Sanktionen, Geldwäschebestimmungen und branchenspezifischen Gesetzen.",
    SustainabilityRisk: "Nachhaltigkeitsrisiko",
    SustainabilityRiskInfo:
      "ESG-Faktoren (Umwelt, Soziales, Unternehmensführung) und Reputationsauswirkungen.",
    IndustryRisk: "Branchenrisiko",
    IndustryRiskInfo:
      "Bewertet die Stabilität und die Zukunftsaussichten des gesamten Sektors eines Unternehmens.",
    LetBegin: "Los geht's",
    AddcompaniesfromSearchResult:
      "Unternehmen aus den Suchergebnissen hinzufügen",
    AddcompaniesfromMyDatabase: "Unternehmen aus meiner Datenbank hinzufügen",
    Addcompaniesbyuploadmyownlist:
      "Unternehmen hinzufügen, indem Sie Ihre eigene Liste hochladen",
    Uploadyourlistofcompanies:
      "Laden Sie Ihre Unternehmensliste hoch, und Risk Scan liefert Ihnen umgehend aktualisierte Daten für jedes Unternehmen. Mit umfassenden Risikoanalysen in acht Risikokategorien wandelt Risk Scan Ihr reaktives Risikomanagement in einen proaktiven strategischen Vorteil um.",
    Select: "Auswählen",
    Upload: "Hochladen",
    Cancel: "Abbrechen",
    Confirm: "Bestätigen",
    UploadFiles: "Dateien hochladen",
    PleaseuploadyourfileinCVSformat:
      "Bitte laden Sie Ihre Datei im xlsx-Format hoch.",
    Downloadxlsxtemplate: "xlsx-Vorlage herunterladen",
    Xcompanieswereuploadedsucessfuly:
      "{0} Unternehmen wurden erfolgreich hochgeladen.",
    Xcompanieswereidentifiedsucessfuly:
      "{0} Unternehmen wurden erfolgreich identifiziert.",
    Xcompanieswerenotmatched: "{0} Unternehmen wurden nicht zugeordnet.",
    Uploadingfilefailed:
      "Datei konnte nicht hochgeladen werden. Bitte verwenden Sie die Vorlage und versuchen Sie es erneut.",
    Uploading: "Hochladen",
    Uploadwithamaximumfilesizeof1M:
      "(Es können maximal 100 Datensätze gleichzeitig hochgeladen werden, mit einer maximalen Dateigröße von 1 MB.)",
    Tryagain: "Versuchen Sie es erneut",
    Theuploadedonlyxlsx:
      "Die hochgeladene Datei darf nur im xls/xlsx-Format vorliegen.",
    Scanning: "Scannen",
    RiskScanning: "Risikoanalyse",
    Youhaveselectedatotalof: "Sie haben ausgewählt",
    Tostartriskscanning:
      'Unternehmen. Klicken Sie auf "Bestätigen", um das Scannen zu beginnen.',
    Datascanningisinprogress: "Die Datenanalyse läuft...",
    LastUpdate: "Letzte Aktualisierung",
    Selectdate: "Datum auswählen",
    UpdateStatus: "Aktualisierungsstatus",
    ClearAll: "Alles löschen",
    ALL: "Alle",
    Updated: "Aktualisiert",
    Notupdated: "Nicht aktualisiert",
    HistoricalData: "Historische Daten",
    Selectrisklevel: "Risikostufe auswählen",
    Low: "Niedrig",
    Average: "Durchschnitt",
    Caution: "Vorsicht",
    NotRated: "Keine Bewertung",
    Reselect: "Neu auswählen",
    HistoricalRecords: "Historische Aufzeichnungen",
    DownloadReport: "Bericht herunterladen",
    SearchLeads: "Interessenten suchen",
    CompanyName: "Name der Firma",
    CompanyID: "Firmen-ID",
    CompanyType: "Unternehmensart",
    RegistrationDate: "Registrierungsdatum",
    RegistrationStatus: "Registrierungsstatus",
    Listed: "an der Börse notiert",
    LegalStatus: "Rechtsstatus",
    NoofShareholders: "Anzahl der Aktionäre",
    ShareholdingLayers: "Aktionärsniveau",
    NoofCorporateShareholders: "Anzahl der institutionellen Aktionäre",
    NoofNatualPersonShareholders: "Anzahl der natürlichen Aktionäre",
    RelatedCompanies: "Verwandte Unternehmen",
    OrganizationalStatus: "Organisationsstatus",
    OperatingAddress: "Betriebsadresse",
    IndustryCode: "Branchenkodex",
    BusinessActivities: "Geschäftstätigkeit",
    NoofEmployees: "Anzahl der Mitarbeiter",
    Management: "Management",
    CurrentOperations: "Aktueller Betrieb",
    Revenue: "Umsatz",
    Assests: "Vermögenswerte",
    ProfitLoss: "Gewinn/Verlust",
    Liquidity: "Liquidität",
    Growth: "Wachstum",
    Performance: "Betriebsleistung",
    CreditRating: "Kredit rating",
    CreditScore: "Kreditwürdigkeit",
    PausibilityofDefault: "Ausfallwahrscheinlichkeit (PD)",
    SolvencyIndex: "Solvenzindex",
    DebtCollection: "Inkasso",
    CreditOpinion: "Kreditbeurteilung",
    CompanySanction: "Unternehmenssanktions",
    ProductSanction: "Produktsanktion",
    ExportControl: "Exportkontrolle",
    AntiCorruptionAntiBribery: "Korruptions und Bestechungsbekämpfung",
    Litigations: "Rechtsstreitigkeiten",
    NegativeNews: "Negative Nachrichten",
    ESGScore: "ESG-Score",
    YearsinBusiness: "Jahre im Geschäft",
    Competitiveness: "Wettbewerbsfähigkeit",
    WorkingCapital: "Marktrisiko",
    FinancialStructure: "Lieferkettenindex",
    Industrystatus: "Branchenstatus",
    IndustryOutlook: "Branchenausblick",
    NoofCompanies: "Anzahl der Unternehmen",
    IndustryRanking: "Branchenranking",
    IndustryConcentration: "Branchen-BIP %",
    IndustryCompetitiveness: "Wettbewerbsfähigkeit der Branche",
    IndustryDevelopment: "Branchenentwicklung",
    Legal: "Recht",
    Organizational: "Organisatorisch",
    Operational: "Operativ",
    Financial: "Finanzielle",
    Credit: "Kredit",
    Compliance: "Einhaltung",
    Sustainability: "Nachhaltigkeit",
    Industry: "Industrie",
    ScanDate: "Scandatum",
    Updating: "Aktualisierung",
    ScanHistoricalData: "Historische Daten scannen",
    StartDate: "Startdatum",
    EndDate: "Enddatum",
    Download: "Herunterladen",
    Entercompanyname: "Firmenname eingeben",
  },
  //Data Management
  DataManagement: {
    DataManagement: "Datenverwaltung",
    AllCompanies: "Alle Unternehmen",
    CompaniesViewed: "Angesehene Unternehmen",
    CompaniesCollected: "Gesammelte Unternehmen",
    CompaniesUploaded: "Hochgeladene Unternehmen",
    MyPortfolio: "Mein Portfolio",
    Date: "Datum",
    CompanyName: "Name der Firma",
    Country: "Land",
    CompanyType: "Unternehmensart",
    CompanyStatus: "Unternehmensstatus",
    DQI: "DQI",
    Download: "Herunterladen",
    Addcompanies: "Unternehmen hinzufügen",
    Filter: "Filtern",
    Selectcountry: "Land auswählen",
    Selectindustry: "Branche auswählen",
    Selectcompanytype: "Firmentyp auswählen",
    Selectcompanysize: "Unternehmensgröße auswählen",
    Selectcompanystatus: "Unternehmensstatus auswählen",
    Selectlistedcompanies: "Ausgewählte gelistete Unternehmen",
    Selectcompanyyearsinbusiness: "Wählen Sie die Jahre der Firmengründung",
    Industry: "Industrie",
    CompanySize: "Unternehmensgröße",
    Listed: "Börsennotierte",
    CompanyAge: "Unternehmensalter",
    SelectYear: "Jahr auswählen",
    SelectQuarter: "Wählen Sie ein Quartal aus",
    SelectMonth: "Monat auswählen",
    Reset: "Zurücksetzen",
    Search: "Suchen",
    MyDatabase: "Meine Datenbank",
    Locations: "Standorte",
    YearsinBusiness: "Jahre im Geschäft",
    CompanyDQI: "DQI",
    RiskScan: "Risikoanalyse",
    CreditAssessment: "Kreditbewertung",
    Uptodate: "Aktuell",
    Average: "Durchschnitt",
    Insufficient: "Unzureichend",
    Good: "Gut",
    Caution: "Vorsicht",
    Unknown: "Unbekannt",
    CompanyTag: "Firmenkennzeichen",
    Remove: "Entfernen",
    Uploaded: "Hochgeladen",
    Identified: "Identifiziert",
    Notmatched: "Nicht zugeordnet",
    UploadCompanies: "Firmen hochladen",
    Match: "Übereinstimmung",
    Delete: "Löschen",
    OnlineMatching: "Online-Matching",
    Identifythecompanywithmanualcheck:
      "Identifizieren Sie das Unternehmen mit manueller Prüfung",
    Identifyacompanymanually: "Manuelle Identifizierung eines Unternehmens",
    Pleaseprovideanyrelevantinformation:
      "Bitte geben Sie alle relevanten Informationen an, die die Suchergebnisse verbessern könnten. Unser Datenanalyst wird Sie mit dem am besten geeigneten Unternehmen zusammenbringen.",
    RegistrationID: "Unternehmens-ID",
    StateProvince: "Bundesland/Provinz",
    Address: "Adresse",
    Otherinformation: "Weitere Informationen",
    Submit: "Einreichen",
    Cancel: "Stornieren",
    Confirm: "Bestätigen",
    EnterRegistrationID: "Registrierungs-ID eingeben",
    EnterAddress: "Adresse eingeben",
    EnterInformation: "Informationen eingeben",
    User: "Benutzer",
    Task: "Aufgabe",
    NoofCompanies: "Anzahl der Unternehmen",
    Entercompanyname: "Firmennamen eingeben",
    SaveYourPortfolio: "Speichern Sie Ihr Portfolio",
    PortfolioName: "Portfolio-Name",
    Notes: "Anmerkungen",
    Edit: "Bearbeiten",
    EnterPortfolioName: "Portfolionamen eingeben",
    EnterUserName: "Benutzer eingeben",
    SelectTaskName: "Aufgabe auswählen",
    EnterNotes: "Geben Sie Notizen ein",
    StartingMonth: "Startmonat",
    EndMonth: "Endmonat",
  },
  Relationship: {
    SearchRelationship: "Such beziehung",
    SearchRelationshipInfo:
      "  ist unser führender Datendienst, der das gesamte Unternehmensökosystem eines jeden Unternehmens transparent macht. Die Plattform bietet eine umfassende 360-Grad-Sicht auf Ihr Zielunternehmen und enthüllt:",
    UltimateOwnershipControl: "Eigentumsverhältnisse und Kontrolle",
    UltimateOwnershipControlInfo:
      "Legen Sie die Eigentumskette offen, indem Sie komplexe Strukturen durchdringen, um wirtschaftlich Berechtigte und alle Aktionäre zu identifizieren.",
    InvestmentParticipation: "Investitionen und Beteiligungen",
    InvestmentParticipationInfo:
      "Entdecken Sie alle Unternehmen, in die das Zielunternehmen investiert hat, mit denen es Partnerschaften eingegangen ist oder an denen es beteiligt war, und decken Sie strategische Ausrichtungen und verborgene Allianzen auf.",
    SupplyChainNetwork: "Lieferkettennetzwerk",
    SupplyChainNetworkInfo:
      "Bilden Sie das gesamte Spektrum der Geschäftsbeziehungen ab und identifizieren Sie alle potenziellen Lieferanten und Kunden, um den gesamten Handelsfluss zu verstehen. ",
    Ourplatformempowers:
      "Unsere Plattform unterstützt Sie bei wichtigen Entscheidungen, indem sie Ihnen hilft, Chancen zu erkennen, Compliance-Prozesse zu optimieren und Risiken zu minimieren. Mit Search Relationship ist Transparenz nur eine Suche entfernt.",
    LetsBegin: "Los geht's",
    CompanyName: "Name der Firma",
    Country: "Land",
    Industry: "Industrie",
    CompanyType: "Unternehmensart",
    CompanySize: "Unternehmensgröße",
    CompanyStatus: "Unternehmensstatus",
    ListingInfo: "Börseninformationen",
    YearsinBusiness: "Betriebsjahre",
    IncDate: "Gründungsdatum",
    HSCode: "HS-Code",
    Company: "Unternehmen",
    Product: "Produkt",
    HsCodeProduct: "HS-Code / Produkt",
    ImportExport: "Import & Export",
    Entercompanyname: "Firmennamen eingeben",
    SelectHsCodeProduct: "HS-Code / Produkt auswählen",
    CompanySnapshot: "Unternehmensprofil",
    Address: "Adresse",
    CountyCity: "Landkreis/Stadt",
    ProvinceState: "Provinz/Bundesland",
    CountryRegion: "Land/Region",
    ZipCode: "Postleitzahl",
    RegName: "Eingetragener Name",
    Website: "Webseite",
    Email: "E-Mail",
    Phone: "Telefon",
    LastUpdate: "Letzte Aktualisierung",
    DataSource: "Datenquelle",
    CompanyProfile: "Unternehmensprofil",
    CoNativeName: "Originale Firmenname",
    CompanyID: "Unternehmens-ID",
    VATNumber: "Umsatzsteuer-Identifikationsnummer",
    StockNumber: "Börsennummer",
    Listed: "Eingetragen",
    RegistrationDate: "Registrierungsdatum",
    LegalForm: "Rechtsform",
    LegalStatus: "Rechtsstatus",
    Jurisdiction: "Gerichtsbarkeit",
    RegisteredAddress: "Registrierte Adresse",
    OperatingAddress: "Betriebsadresse",
    Ownership: "Eigentum",
    Investments: "Investitionen",
    PossibleVendors: "Mögliche Anbieter",
    PossibleClients: "Mögliche Kunden",
    UItimateBeneficiaryOwner: "Endgültiger Begünstigter Eigentümer (UBO)",
    ControllingShareholder: "Kontrollierender Aktionär",
    Participations: "Teilnahmen",
    ShareholdingLayers: "Aktionärsniveau",
    PartiesInvolved: "Beteiligte Parteien",
    RelatedCompanies: "Verwandte Unternehmen",
    CompanyShareholders: "Unternehmensaktionäre",
    CoShareholders: "Unternehmensaktionäre",
    NGOShareholders: "NGO-Aktionäre",
    NaturalPersonShareholders: "Natürliche Person Aktionär",
    SubjectsInvestments: "Investitionen des Subjekts",
    CorporateShareholders: "Aktionäre",
    Name: "Name",
    Location: "Standort",
    Type: "Typ",
    Shares: "Anteile (%)",
    Relations: "Beziehungen",
    TotalEntities: "Gesamtzahl der Einheiten",
    Entities: "Unternehmen",
    Subsidiaries: "Subsidiaries",
    Countries: "Länder",
    Branches: "Niederlassungen",
    Relationship: "Beziehung",
    RelationType: "Beziehungstyp",
    RelationLevel: "Beziehungsebene",
    Management: "Management",
    ContactInfo: "Kontaktinformationen",
    Position: "Position",
    Department: "Abteilung",
    ShareholderorNot: "Aktionär oder nicht",
    Pleaseentername: "Bitte Namen eingeben",
    SupplyChain: "Lieferkette",
    PossibleClients: "Mögliche Kunden",
    PossibleSuppliers: "Mögliche Lieferanten",
    Banking: "Bankwesen",
    TotalSales: "Gesamtumsatz",
    TotalPurchasing: "Gesamteinkauf",
    ActivePlayers: "Aktive Spieler",
    MainProductsServices: "Hauptprodukte/Dienstleistungen",
    TotalTradingVolume: "Gesamthandelsvolumen",
    TransactionTotal: "Transaktion/Gesamt (%)",
    RecentTradeDate: "Aktuelles Handelsdatum",
    IndustryCode: "Branchencode",
    TradeRelatedCompanies: "Verwandte Unternehmen",
    TradeRelatedProductTOP10: "Verwandte Produkte (Top 10)",
    Numberofshareholderenterprises: "Anzahl der Aktionärsunternehmen",
    CurrentLevel: "Aktuelles Niveau",
    SharesonSubjectCo: "Aktien der betreffenden Gesellschaft",
    EnterCurrentLevel: "Aktuelles Level eingeben",
    EnterCountry: "Land eingeben",
    ClearAll: "Alles löschen",
    ShareholderLevel: "Aktionärsschichten",
    DirectShareholdingPercentage: "Direkte Beteiligungsquote",
    TotalOwnershipPercentage: "Gesamtbeteiligungsquote",
    InvestmentHoldingLevel: "Investitionsbeteiligungsniveau",
  },
  SearchSanctions: {
    CountryISO: "Länder-ISO",
    Currency: "Währung",
    Language: "Sprache",
    SanctionOtherCountries: "Andere Länder sanktionieren",
    SanctionedbyOtherCountries: "Von anderen Ländern sanktioniert",
    CountriesTerritories: "Länder/Gebiete",
    Selectcountryterritory: "Land/Gebiet auswählen",
    Noofcountriessanctionedby: "Anzahl der von {0} sanktionierten Länder",
    Noofcountriesthatsanctioned:
      "Anzahl der Länder, die {0} sanktioniert haben",
    Noofsanctionedcompanies: "Anzahl der sanktionierten Unternehmen",
    Noofsanctionedpersonnel: "Anzahl der sanktionierten Mitarbeiter",
    SanctionOverview: "Sanktionsübersicht",
    NoofSanctions: "Anzahl der Sanktionen",
    TypesofSanctions: "Arten von Sanktionen",
    SourceofSanctions: "Quelle der Sanktionen",
    Provider: "Anbieter",
    Description: "Beschreibung",
    Details: "Einzelheiten",
    ClearAll: "Alle löschen",
    Sanctions: "Sanktionen",
    SanctionID: "Sanktions-ID",
    SelectsanctionID: "Sanktions-ID auswählen",
    SanctionedType: "Sanktionierter Typ",
    SelectSanctionedType: "Sanktionstyp auswählen",
    CompanyPersonnel: "Unternehmen/Person",
    Selectcompanypersonnel: "Firma/Personal auswählen",
    SanctionCategory: "Sanktionskategorie",
    Selectsanctioncategory: "Sanktionskategorie auswählen",
    SanctionSource: "Sanktionsquelle",
    Selectsanctionsource: "Sanktionsquelle auswählen",
    Status: "Status",
    Selectstatus: "Status auswählen",
    CountryofSource: "Herkunftsland",
    Name: "Name",
    SanctionedCountries: "Sanktionierte Länder",
    SanctionType: "Sanktionstyp",
    Reference: "Referenz",
    ProviderCode: "Anbietercode",
    RecordSource: "Datensatzquelle",
    CompanyName: "Firmenname",
    Country: "Land",
    SelectCompanyName: "Firmenname auswählen​",
    SelectCountry: "Land auswählen",
    SanctionInfo: "Sanktionsinformationen",
    SanctionRelated: "Sanktionsbezogen",
    OwnershipRelatedCompanies: "Eigentum & verbundene Unternehmen",
    OfficialSanctionList: "Offizielle Sanktionsliste",
    RegName: "Reg.-Name",
    Address: "Adresse",
    Website: "Webseite",
    Email: "E-Mail",
    ProvinceState: "Provinz/Bundesland",
    Tel: "Tel.",
    CountryRegion: "Land/Region",
    LastUpdate: "Letzte Aktualisierung",
    ZipCode: "PLZ",
    DataSource: "Datenquelle",
    Relations: "Beziehungen",
    ProfileNotes: "Profilnotizen",
    DOB: "Geburtsdatum",
    Gender: "Geschlecht",
    All: "Alle",
    FirstName: "Vorname",
    MiddleName: "Zweiter Vorname",
    LastName: "Nachname",
    PreviousName: "Vorheriger Name",
    Type: "Typ",
    PlaceofBirth: "Geburtsort",
    Citizenship: "Staatsangehörigkeit",
    Residence: "Wohnsitz",
    Juristiction: "Gerichtsbarkeit",
    History: "Geschichte",
    Category: "Kategorie",
    Title: "Titel",
    SanctionRecord: "Sanktionsdatensatz",
    Relationship: "Beziehung",
    HSCode: "HS-Code",
    ProductName: "Produktname",
    SanctionedCountryRegion: "Sanktioniertes Land/Region",

    //未对应
    LawEnforcement: "Strafverfolgung",
    EnforcementOrders: "Durchsetzungsanordnungen",
    Warnings: "Warnungen",
    FinancialSanctions: "Finanzsanktionen",
    ExclusionList: "Ausschlussliste",
    TradeRestrictions: "Handelsbeschränkungen",
    VisaTravelBan: "Visum-/Reiseverbot",
    WarCrimes: "Kriegsverbrechen",
    NoData: "Keine Daten",
    Advisories: "Warnhinweise",
    Others: "Sonstige",
    Selectsanctiontype: "Sanktionstyp auswählen",
    Selectreference: "Referenz auswählen",
    From: "Von",
    To: "Bis",
    CountryCity: "Land/Stadt",
    Sources: "Quellen",

    SearchPersonName: "Personennamen suchen",
    SelectDOB: "Geburtsdatum auswählen",
    Male: "Männlich",
    Female: "Weiblich",
    SelectRecordSource: "Datensatzquelle auswählen",
    DescriptionofReferenceName: "Beschreibung des Referenznamens",
    SelectHSCode: "HS-Code auswählen",
    SelectProductName: "Produktnamen auswählen",
    SelectSanctionedCountryRegion: "Sanktioniertes Land/Region auswählen",
  },
  SearchTrade: {
    LastUpdate: "Letzte Aktualisierung",
    ProductCode: "Produktcode",
    ProductDescription: "Produktbeschreibung",
    Sanctions: "Sanktionen",
    TotalImports: "Gesamtimporte",
    TotalExports: "Gesamtexporte",
    TotalImportWeight: "Gesamtimportgewicht",
    TotalExportWeight: "Gesamtexportgewicht",
    NumberofSuppliers: "Anzahl der Lieferanten",
    NumberofBuyers: "Anzahl der Käufer",
    NumberofOriginCountries: "Anzahl der Herkunftsländer",
    NumberofDestinationCountries: "Anzahl der Zielländer",
    TradeMap: "Handelskarte",
    Imports: "Importe",
    Exports: "Exporte",
    Reset: "Zurücksetzen",
    Product: "Produkt",
    Destination: "Bestimmungsort",
    Origin: "Herkunft",
    NoData: "Keine Daten",
    Date: "Datum",
    TotalTransactions: "Gesamttransaktionen",
    Transactions: "Transaktionen",
    TradeRanking: "Handelsranking",
    Top5Ranking: "Top-5-Rangliste‌",
    Growth: "Wachstum",
    Decline: "Rückgang",
    TradeTrends: "Handelstrends",
    TradeVolume: "Handelsvolumen",
    MonthonMonthRatio: "Monatsvergleichsquote",
    Suppliers: "Lieferanten",
    Buyers: "Käufer",
    Startdate: "Startdatum",
    Enddate: "Enddatum",
    SelectCountry: "Land auswählen",
    SelectCompany: "Unternehmen auswählen",
    ClearAll: "Alles löschen",
    TransactionDate: "Transaktionsdatum",
    SelectTransactionDate: "Handelsdatum auswählen",
    Company: "Unternehmen",
    CompanyName: "Firmenname",
    Country: "Land",
    Industry: "Branche",
    Enterkeywords: "Schlüsselwörter eingeben",
    SupplierOverview: "Lieferantenübersicht",
    BuyerOverview: "Käuferübersicht",
    CompanyID: "Firmen-ID",
    ISIC: "ISIC",
    ISICDescription: "ISIC-Beschreibung",
    TotalTradeAnnual: "Gesamthandel (Jährlich)",
    TotalTradePastsixmonth: "Gesamthandel (Letzte 6 Monate)",
    ContactInformation: "Kontaktinformationen",
    ShippingOverview: "Versandübersicht",
    TradeHistoryandTrends: "Handelshistorie und Trends",
    SupplyChainList: "Lieferkettenliste",
    PossibleBuyers: "Mögliche Käufer",
    PossibleSuppliers: "Mögliche Lieferanten",
    ShowAll: "Alle anzeigen",
    TotalExportsAnnual: "Gesamtexporte (Jährlich)",
    TotalImportsAnnual: "Gesamtimporte (Jährlich)",
    ExportAmount: "Exportbetrag",
    ImportAmount: "Importbetrag",
    ShipmentDetail: "Sendungsdetails",
    Entersuppliername: "Lieferantennamen eingeben",
    Enterbuyername: "Käufernamen eingeben",
    SupplierName: "Lieferantenname",
    BuyerName: "Käufername",
    TotalAmount: "Gesamtbetrag",
    Details: "Details",
    WaybillDetails: "Frachtbriefdetails",
    ListofOrigins: "Liste der Herkunftsländer",
    ListofDestinations: "Liste der Bestimmungsorte‌",
    ISO: "ISO",
    Currency: "Währung",
    Language: "Sprache",
    Address: "Adresse",
    OverviewofSupplyChainInformation: "Übersicht der Lieferketteninformationen",
    OriginInformationOverview: "Übersicht der Herkunftsinformationen",
    DestinationInformationOverview: "Übersicht der Zielinformationen",
    SanctionType: "Sanktionierter Typ",
    SelectSanctionType: "Sanktionsart auswählen",
    SanctionedCountryRegion: "Sanktioniertes Land/Region",
    SelectSanctionedCountryRegion: "Sanktioniertes Land/Region auswählen",
    HSCode: "HS-Code",
    SanctionedProductsOverview: "Übersicht sanktionierter Produkte",
    Searchmoresanctiononothercompanies:
      "Weitere Sanktionen bei anderen Unternehmen suchen",
    SimilarProducts: "Ähnliche Produkte",
    Numberofsimilarproducts: "Anzahl ähnlicher Produkte",
    TopImportCountries: "Top 5 Importländer",
    TopExportCountries: "Top 5 Exportländer",
    PleaseSelect: "Bitte auswählen",
    EnterHSCodeProductName: "HS-Code & Produktname eingeben",
    ImportProducts: "Importprodukte",
    ExportProducts: "Exportprodukte",
    NumberofOrigin: "Anzahl der Herkunftsländer",
    NumberofDestination: "Anzahl der Zielländer",
    NumberofImportProducts: "Anzahl der Importprodukte",
    NumberofExportProducts: "Anzahl der Exportprodukte",
    ProductName: "Produktname",
    SelectProductName: "Produktname auswählen",
    TopExportProducts: "Top 5 Exportprodukte",
    TopImportProducts: "Top 5 Importprodukte",
    ExportProductOverview: "Exportproduktübersicht",
    ImportProductOverview: "Importproduktübersicht",
    CompanyCompetitiveness: "Wettbewerbsfähigkeit des Unternehmens",
    GlobalMarketShare: "Weltmarktanteil‌",
    RegionalMarketShare: "Regionaler Marktanteil",
    BusinessGrowthGlobalMarket: "Geschäftswachstum (Globaler Markt)",
    BusinessGrowthRegionalMarket: "Geschäftswachstum (Regionaler Markt)",
    CreditRating: "Kreditrating",
    CreditAssessment: "Kreditbewertung",
    LocalCreditScore: "Lokale Kreditwürdigkeit",
    SolvencyIndex: "Solvenzindex",
    ProbabilityofDefault: "Ausfallwahrscheinlichkeit",
    RiskIndicator: "Risikoindikator",
    RelatedCreditAssessment: "Verwandte Kreditbewertung",
    HighRisk: "Hohes Risiko",
    Medium: "Mittel",
    Moderate: "Mäßig",
    Average: "Durchschnitt",
    LowerThanAvg: "Unter dem Durchschnitt",
    LowRisk: "Niedriges Risiko",
    CreditOpinion: "Kreditmeinung",
    ComparisonofSimilarProducts: "Vergleich ähnlicher Produkte",
    AddProduct: "Produkt hinzufügen",

    RegistrationDate: "Registrierungsdatum",
    Profit: "Gewinn",
    NoofShareholders: "Anzahl der Aktionäre",
    TotalAssets: "Gesamtvermögen",
    IndustryCode: "Branchencode",
    CreditRating: "Kreditrating",
    NoofEmployees: "Anzahl der Mitarbeiter‌",
    CreditScore: "Kredit-Score",
    Listed: "Börsennotiert",
    ESGRating: "ESG-Bewertung",
    Revenue: "Umsatz",
    DQI: "DQI",
    MoreCoDetails: "Weitere Unternehmensdetails",
    CoNews: "‌Unternehmensnachrichten‌",
    MoreCoNews: "Weitere Unternehmensnachrichten‌",
    IndustryMean: "Branchenmittelwert",
    TargetSubjectRevenue: "Zielsubjekt-Einnahmen",
    ImportCountries: "Importländer",
    ExportCountries: "Exportländer",
    ImportCompanyTop: "Importunternehmen Nr. 1",
    ExportCompanyTop: "Exportunternehmen Nr. 1",
    TopImportCountry: "Top Importland",
    TopExportCountry: "Top Exportland",
    Max: "Max",
    Min: "Min",
    Subject: "Objekt",
    ReturnonEquity: "Eigenkapitalrendite",
    ProfitMargin: "Gewinnspanne",
  },

  TradeByCountry: {
    ImpExpCountries: "Imp & Exp Länder",
    ImpExpCompanies: "Imp & Exp Unternehmen",
    ImpExpProducts: "Imp & Exp Produkte",
    Assessment: "Bewertung",
    TotalImportAmount: "Gesamt Import Wert",
    GlobalImportShare: "Globaler Import Anteil",
    ImportGrowth: "Import Wachstum",
    TotalExportAmount: "Gesamt Export Wert",
    GlobalExportShare: "Globaler Export Anteil",
    ExportGrowth: "Export Wachstum",
    TradeBalance: "Handelsbilanz",
    CountryData: "Länderdaten",
    GDP: "BIP",
    GDPPPP: "BIP (Kaufkraftparität)",
    ExportsofGoods: "Warenexporte",
    ExportsofServices: "Dienstleistungsexporte",
    ImportsofGoods: "Warenimporte",
    ImportsofServices: "Dienstleistungsimporte",
    CPI: "‌VPI‌",
    Population: "Bevölkerung",
    ContainerPortThroughput: "Containerumlauf in Häfen",
    DistributionofImportExportCountries:
      "Verteilung der Import- und Exportländer",
    Top5Ranking: "Top-5-Rangliste‌",
    Importers: "Importeure",
    Exporters: "Exporteure",
    ImportCountries: "Import Länder",
    ExportCountries: "Export Länder",
    ImportProducts: "Import Produkte",
    ExportProducts: "Export Produkte",
    CountryImportExportOverview:
      "Übersicht über Import und Export eines Landes",
    Year: "Jahr",
    Amount: "Betrag (USD)",
    Balance: "Bilanz",
    CountryTradeDataComparison: "Vergleich der Handelsdaten von Ländern",
    Comparison: "Vergleich",
    AddSample: "Beispiel hinzufügen",
    AddCriteria: "Kriterium hinzufügen",
    ImportCountry: "Importland",
    Selectimportcountries: "Importländer auswählen",
    ExportCountry: "Exportland",
    Selectexportcountries: "Exportländer auswählen",
    EnterHSCodeProductName: "HS Code und Produktname eingeben",
    Afterselectingthecriteria:
      "Nach der Auswahl der Kriterien werden die Vergleichsergebnisse angezeigt.",
    ShowResult: "Ergebnis anzeigen",
    ListofTradeCompanies: "Liste der Handelsunternehmen",
    TotalCompanies: "Gesamtanzahl der Unternehmen",
    Top5Products: "Top 5 Produkte",
    ListofExportProducts: "Liste der Exportprodukte",
    ListofImportProducts: "Liste der Importprodukte",
    Top5ExportCountries: "Top 5 Exportländer",
    Top5ImportCountries: "Top 5 Importländer",
    HSDescription: "HS-Beschreibung",
    HSCode: "HS-Code",

    TradeCompetitivenessIndex: "Handelswettbewerbsindex",
    TotalTradeAmount: "Gesamthandelsbetrag",
    NetTradeBalance: "Nettohandelsbilanz",
    TradeGap: "Handelslücke",
    TradeGoodsExports: "Warenhandelsexporte",
    TradeGoodsImports: "Warenhandelsimporte",
    TradeServicesExports: "Dienstleistungshandelsexporte",
    TradeServicesImports: "Dienstleistungshandelsimporte",
    CompositePMI: "Gesamt-PMI",
    ServicesPMI: "Dienstleistungs-PMI",
    LegalEnvironment: "Rechtliches Umfeld",
    CorporateTaxRate: "Körperschaftsteuersatz",
    PersonalIncomeTaxRate: "Einkommensteuersatz",
    SalesTaxRate: "Umsatzsteuersatz",
    BusinessConfidenceIndex: "Geschäftsklimaindex",
    CountryRating: "Länderrating",
    CompetitivenessIndex: "Wettbewerbsindex",
    CompetitivenessRank: "Wettbewerbsrang",
    EaseofDoingBusiness: "Leichtigkeit der Geschäftstätigkeit",
    BusinessConfidence: "Geschäftsvertrauen",
    ConsumerConfidence: "Verbrauchervertrauen",
    BusinessClimateAssessment: "Bewertung des Geschäftsklimas",
    SP: "S&P",
    Moodys: "Moody's",
    Fitch: "Fitch",
    DBRS: "DBRS",
    Allianz: "Allianz",
    Coface: "Coface",
    Atradius: "Atradius",
    OECD: "OECD",
    Productivecapacitiesindex: "Produktivitätskapazitätsindex",
    PleaseSelect: "Bitte auswählen",
    transactionvolume: "Transaktionsvolumen",
    Growth: "Wachstum",
    Decline: "Rückgang",
    SelectCountry: "Land auswählen",
    TradeVolume: "Handelsvolumen",
    Youcanonlyaddupto5datacomparisonitems:
      "Sie können nur bis zu 5 Datenvergleichsobjekte hinzufügen",
    DataComparisonActive: "DataComparisonActive",
    DataComparisonBlack: "DataComparisonBlack",
    ProductName: "Produktname",
    Product: "Produkt",
    EnterproductnameorHSCode: "Produktnamen oder HS-Code eingeben",
    Date: "Datum",
    OverviewofAnalysisContent: "Übersicht des Analyseinhalts",
    Afterselectingthecriteria: "Nach Auswahl der Kriterien,",
    thecomparisonresultwillbedisplayed:
      "wird das Vergleichsergebnis angezeigt.",
    ImportExport: "Import & Export",
    All: "Alle",
    Company: "Unternehmen",
    SelectCompanyName: "Unternehmensnamen auswählen",
    SelectProductName: "Produktnamen auswählen",
    CompanyID: "Unt.-ID",
    CO: " C/O",
    ISIC: "ISIC",
    ISICDescription: "ISIC-Beschreibung",
    Top5ExportProducts: "Top 5 Exportprodukte",
    Top5ImportProducts: "Top 5 Importprodukte",
    ContactInformation: "Kontaktinformationen",
    SearchTrade: "Handel suchen",
    NumberofImportProducts: "Anzahl der Importprodukte",
    NumberofExportProducts: "Anzahl der Exportprodukte",
    TransactionYear: "Transaktionsjahr",
    SelectTransactionYear: "Transaktionsjahr auswählen",
    Totalnumberofimportedproducts: "Gesamtzahl importierter Produkte",
    Totalnumberofexportedproducts: "Gesamtzahl exportierter Produkte",
    Updateyear: "Aktualisierungsjahr",
    TotalTrade: "Gesamthandel",
    ISO: "ISO",
    Currency: "Währung",
    Language: "Sprache",
  },
  LeadsAIAssistance: {
    SavedAnswers: "Gespeicherte Antworten",
    SearchLeads: "Suche nach Leads",
    SearchLeadsMessage1:
      "„Suchanfragen“ ist ein leistungsstarkes Tool, das Unternehmen dabei unterstützt, potenzielle Kunden oder Lieferanten zu finden. Unsere Plattform nutzt modernste Machine-Learning-Technologie, um umfangreiche Datensätze zu analysieren und maßgeschneiderte, präzise Empfehlungen zu liefern. ",
    SearchLeadsMessage2:
      "Das System berücksichtigt Nutzerziele, Markttrends, Risikobereitschaft und historische Daten, um Produkte oder Dienstleistungen zu ermitteln, die optimal zu ihren Bedürfnissen und Präferenzen passen.",
    SearchLeadsMessage3:
      "„Suchanfragen“ lernt und entwickelt sich kontinuierlich weiter und stellt so sicher, dass die Empfehlungen relevant und korrekt bleiben. Durch die Bereitstellung umsetzbarer Erkenntnisse ermöglicht es Unternehmen, Zeit und Ressourcen zu sparen und gleichzeitig die vielversprechendsten Kunden oder Lieferanten zu identifizieren.",
    SearchLeadsMessage4:
      "Damit das System Ihnen eine Liste von Unternehmen empfehlen kann, benötigen wir einige Antworten von Ihnen.",
    LetBegin: "Los geht’s!",
    Selectallthatapply: "Zutreffendes auswählen",
    Savemyanswers: "Meine Antworten speichern",
    Showresults: "Ergebnisse anzeigen",
    Yoursearchcriteriaforcustomeracquisition:
      "Ihre Suchkriterien für die Kundengewinnung",
    Doyouliketosaveyourcurrentselectionsofsearchcriteria:
      "Möchten Sie Ihre aktuelle Auswahl an Suchkriterien speichern?",
    Pleasenameyourcondition: "Bitte geben Sie Ihre Bedingung an.",
    Pleaseenterthetemplatename: "Bitte geben Sie den Vorlagennamen ein.",
    NoSave: "Nein, speichern",
  },
  SearchLeadsList: {
    Filters: "Filter",
    Questionnaire: "Fragebogen",
    Country: "Land",
    CompanyType: "Firmenart",
    CompanySize: "Firmengröße",
    OperationalStatus: "Betriebsstatus",
    YearsinBusiness: "Geschäftsjahre",
    NumberofEmploees: "Anzahl Mitarbeiter",
    Fortune500: "Fortune 500",
    Listed: "Börsennotiert",
    ImportExport: "Import & Export",
    TotalAssets: "Gesamtvermögen",
    Revenue: "Umsatz",
    Profitability: "Rentabilität",
    CreditRating: "Bonitätsbewertung",
    Foundover: "Gefunden über",
    Changeseach: "Suche ändern",
    Refreshformore: "Aktualisieren für mehr",
    CompanyNumber: "Unt.-ID",
    Address: "Adresse",
    Lockinlist: "In Liste sperren",
    ContactInformation: "Kontaktinformationen",
    SupplyChainList: "Lieferkettenliste",
    IndustryInfo: "Brancheninformationen",
    LeadScore: "Blei-Score",
    AccuracyScale: "Genauigkeitsskala",
    RegistrationDate: "Registrierungsdatum",
    Profit: "Gewinn",
    NoofShareholders: "Anzahl der Gesellschafter",
    TotalAssets: "Gesamtvermögen",
    IndustryCode: "Branchencode",
    CreditRating: "Bonitätsbewertung",
    NoofEmployees: "Mitarbeiterzahl",
    CreditScore: "Kreditscore",
    Listed: "Börsennotiert",
    ESGRating: "ESG-Rating",
    Revenue: "Umsatz",
    DQI: "DQI",
    MoreCoDetails: "Weitere Unt.-Details",
    CoNews: "Unt.-Nachrichten",
    MoreCoNews: "Weitere Unt.-Nachrichten",
    NationalIndustryData: "Nationale Branchendaten",
    LastUpdate: "Letzte Aktualisierung",
    IndustryandCountryOverview: "Branchen- und Länderübersicht",
    CountryName: "Ländername",
    BusinessEnvironment: "Geschäftsumfeld",
    LegalEnvironment: "Rechtliches Umfeld",
    ConfidenceIndex: "Vertrauensindex",
    NationalCompetitivenessIndex: "Nationaler Wettbewerbsindex",
    NationalGDP: "Nationales BIP",
    Industrysituationoftheaffiliatedcompany:
      "Branchensituation des verbundenen Unternehmens",
    Subjectcompanyindustrydescription:
      "Branchenbeschreibung des Zielunternehmens",
    Targetenterpriseindustrycode: "Branchencode des Zielunternehmens",
    Industryscalesegmentation: "Segmentierung nach Branchenumfang",
    Quantity: "Menge",
    SubjectCompany: "Zielunternehmen",
    // Large:"Large",
    // Micro:"Micro",
    // SME:"SME",
    // Medium:"Medium",
    Industryyearsegmentation: "Segmentierung nach Branchenjahren",
    Industryoperationsituation: "Betriebslage der Branche",
    Tips: "Tipps",
    Areyousureyouwanttodeletethisdata:
      "Sind Sie sicher, dass Sie diese Daten löschen möchten",
  },
  SearchLeadsContact: {
    ContactInformation: "Kontaktinformationen",
    OrganizationalFramework: "Organisationsrahmen",
    NumberofPersonnel: "Anzahl der Mitarbeiter",
    NumberofDepartments: "Anzahl der Abteilungen",
    NumberofCalls: "Anzahl der Anrufe",
    NumberofEmails: "Anzahl der E-Mails",
    MiningRate: "Erschließungsquote",
    AuthenticationRate: "Authentifizierungsrate",
    Name: "Name",
    Department: "Abteilung",
    Position: "Position",
    Country: "Land",
    Email: "E-Mail",
    Phone: "Telefon",
    SocialMediaAccounts: "Social-Media-Konten",
    AuthenticationStatus: "Authentifizierungsstatus",
    AddStatus: "Status hinzufügen",
    Doyouhaveanemailaddress: "Haben Sie eine E-Mail-Adresse?",
    Isthereatelephone: "Gibt es ein Telefon?",
    Authenticationrequired: "Authentifizierung erforderlich",
    Addornot: "Hinzufügen oder nicht?",
    Added: "Hinzugefügt",
    BulkEmailSending: "Massen-E-Mail-Versand",
    BatchAuthentication: "Stapelauthentifizierung",
    AddCustomers: "Kunden hinzufügen",
    AIEmailAssistant: "KI-E-Mail-Assistent",
    ClearAll: "Alle löschen",
    EnterName: "Namen eingeben",
    EnterDepartment: "Abteilung eingeben",
    EnterPosition: "Position eingeben",
    EnterCountry: "Land eingeben",
    Yes: "Ja",
    No: "Nein",
    EnterSocialMediaAccount: "Social-Media-Konto eingeben",
    Certified: "Verifiziert",
    Unverified: "Nicht verifiziert",
    InformationAuthentication: "Informationsauthentifizierung",
    AuthenticationMethod: "Authentifizierungsmethode",
    Iwanttoclaimit: "Ich möchte es beanspruchen",
    IwanttoclaimitMessage:
      "Sie können Personen, die Sie kennen, authentifizieren.",
    AuthenticationService: "Authentifizierungsdienst",
    AuthenticationServiceMessage:
      "Sie können die zu authentifizierenden Mitarbeiter auswählen und den Offline-Authentifizierungsdienst für das System initiieren.",
    UploadedList: "Hochgeladene Liste",
    DownloadTemplate: "Vorlage herunterladen",
    Upload: "Hochladen",
    ListofCertifiedPersonnel: "Liste zertifizierter Personen",
    AIEmailAssistantTitle:
      "Vielen Dank, dass Sie den KI-E-Mail-Assistenten verwenden.",
    AIEmailAssistantMessage:
      "Wir werden künstliche Intelligenz einsetzen, um die Mitarbeiter und Kontaktdaten des Zielunternehmens genauer zu untersuchen.",
    EmailSending: "E-Mail-Versand",
    RecipientInformation: "Empfängerinformationen",
    SelectedList: "Ausgewählte Liste",
    Pleaseenteryourname: "Bitte geben Sie Ihren Namen ein",
    SenderInformation: "Absenderinformationen",
    CompanyName: "Name der Firma",
    EmailContent: "E-Mail-Inhalt",
    EmailConfirmationMessage: "E-Mail-Bestätigungsnachricht",
    Hellodearuser: "Hallo lieber Benutzer",
    Message:
      "Der Absender dieser E-Mail hat die Kontaktdaten Ihres Unternehmens über die CSI-Plattform gefunden und möchte mit Ihnen in Kontakt treten. Sie können direkt auf die E-Mail antworten, um eine Geschäftsbeziehung aufzubauen, oder sich an den Kundenservice der Plattform wenden. Das System wird dann den Absender für Sie kontaktieren.",
    CSIWebsite: "CSI-Webseite",
    CSICustomerServiceEmail: "CSI-Kundenservice-E-Mail",
    EnterCompanyName: "Firmennamen eingeben",
    EnterEmail: "E-Mail eingeben",
    EnterPhone: "Telefon eingeben",
    Pleaseenteremailcontent: "E-Mail-Inhalt eingeben",
    Cancel: "Abbrechen",
    Submit: "Senden",
    Return: "Zurückkehren",
    Close: "Schließen",
    All: "Alle",
    Addcustomerconfirmationlist: "Kundenbestätigungsliste hinzufügen",
    AddCustomersMessage:
      "Bitte bestätigen Sie, ob es notwendig ist, die Personen in der Tabelle meiner Kundenliste hinzuzufügen. (Persönliches Center)",
    Addlist: "Liste hinzufügen",
  },
  ...deLocale,
};

export default de;
